import request from "@/utils/request";
/*
0、公用
*/
// 根据护照号获取护照信息 1、是护照号 0是员工编码
export function getUsersCode(params) {
  return request({
    url: `/api/v1/users/${params.code}`,
    method: "get",
    params,
  });
}

//银行信息
export function getBankAccountBasic(params) {
  return request({
    url: `/api/v1/bankAccount/basic`,
    method: "get",
    params,
  });
}

//基本信息
export function getGeneralBasic(params) {
  return request({
    url: `/api/v1/general/basic`,
    method: "get",
    params,
  });
}

//飞行路线
export function getAirlinesAll(params) {
  return request({
    url: `/api/v1/airline/all`,
    method: "get",
    params,
  });
}

//获取全部公司或政府或出票机构或医保公司
export function getGovernmentSystemDicAll(params) {
  return request({
    url: `/api/v1/governmentSystemDic/all`,
    method: "get",
    params,
  });
}

//审核记录
export function getApprovalLogs(params) {
  return request({
    url: `/api/v1/${params.name}/approvalLogs`,
    method: "get",
    params,
  });
}

/*
1、机票撤离相关-撤离
*/

//1-1 获取机票撤离列表
export function getDemobilizationApplications(params) {
  return request({
    url: "/api/v1/demobilizationApplications",
    method: "get",
    params,
  });
}

//1-1-1 列表员工
export function getDemobilizationApplications2(params) {
  return request({
    url: "/api/v1/employee/demobilizationApplications",
    method: "get",
    params,
  });
}

//1-2 机票撤离添加表格
export function addDemobilizationApplications(data) {
  return request({
    url: "/api/v1/demobilizationApplication/add",
    method: "post",
    data,
  });
}

export function addDemobilizationApplications2(data) {
  return request({
    url: "/api/v1/employee/demobilizationApplication/add",
    method: "post",
    data,
  });
}

//1-3 获取全部飞行路线
export function getTicketGroupAll(params) {
  return request({
    url: "/api/v1/ticketGroups/all",
    method: "get",
    params,
  });
}

// 1-4 获取详情
export function getDemobilizationApplicationsItem(params) {
  return request({
    url: `/api/v1/demobilizationApplications/${params.key}`,
    method: "get",
    params,
  });
}

export function getDemobilizationApplicationsItem2(params) {
  return request({
    url: `/api/v1/employee/demobilizationApplication/${params.key}`,
    method: "get",
    params,
  });
}

//1-5 修改撤离
export function updateDemobilizationApplication(data) {
  return request({
    url: "/api/v1/demobilizationApplication/edit",
    method: "post",
    data,
  });
}
export function updateDemobilizationApplication2(data) {
  return request({
    url: "/api/v1/employee/demobilizationApplication/edit",
    method: "post",
    data,
  });
}

//2-6 删除
export function deleteDemobilizationApplication(params) {
  return request({
    url: `/api/v1/demobilizationApplication/delete`,
    method: "delete",
    params,
  });
}
export function deleteDemobilizationApplication2(params) {
  return request({
    url: `/api/v1/employee/demobilizationApplication/delete`,
    method: "delete",
    params,
  });
}

//2-7 合并
export function demobilizationApplicationTicketBooking(data) {
  return request({
    url: `/api/v1/demobilizationApplication/ticketBooking`,
    method: "put",
    data,
  });
}

//2-8 修改外事关系
export function putDemobilizationApplicationItem(data) {
  return request({
    url: `/api/v1/demobilizationApplication/put`,
    method: "post",
    data,
  });
}

export function putDepartureDateOverseas(data) {
  return request({
    url: `/api/v1/demobilizationApplication/departureDateOverseas/put`,
    method: "post",
    data,
  });
}

/*
2、机构资质
*/

// 2-1 机构资质列表
export function getOrgQualifications(params) {
  return request({
    url: "/api/v1/orgQualifications",
    method: "get",
    params,
  });
}

//2-2 下载机构资质导入模板
export function importOrgQualifications(params) {
  return request({
    url: "/api/v1/orgQualification/import/template",
    method: "get",
    params,
  });
}

//2-3 导入模板
export function importOrgQualificationsTemplate(data) {
  return request({
    url: "/api/v1/orgQualification/import",
    method: "post",
    data,
  });
}

// 2-4 导出数据
export function exportOrgQualifications(params) {
  return request({
    url: "/api/v1/orgQualification/export",
    method: "get",
    params,
  });
}

//2-5 新建表格
export function addOrgQualification(data) {
  return request({
    url: "/api/v1/orgQualification/add",
    method: "post",
    data,
  });
}

//2-6 修改
export function updateOrgQualification(data) {
  return request({
    url: "/api/v1/orgQualification/update",
    method: "post",
    data,
  });
}

//2-7 详情
export function getOrgQualificationsItem(params) {
  return request({
    url: `/api/v1/orgQualifications/${params.id}`,
    method: "get",
    params,
  });
}

//2-8 删除
export function deleteOrgQualificationItem(data) {
  return request({
    url: `/api/v1/orgQualification/delete`,
    method: "delete",
    data,
  });
}

/*
3、政府授权
*/

// 3-1 政府授权列表
export function getGovSystems(params) {
  return request({
    url: "/api/v1/governmentSystemDics",
    method: "get",
    params,
  });
}

//3-2 下载政府授权导入模板
export function importGovSystem(params) {
  return request({
    url: "/api/v1/govSystem/import/template",
    method: "get",
    params,
  });
}

//3-3 政府授权导入模板
export function importGovSystemTemplate(data) {
  return request({
    url: "/api/v1/govSystem/import",
    method: "post",
    data,
  });
}

//3-4 导出
export function exportGovSystem(params) {
  return request({
    url: "/api/v1/govSystem/export",
    method: "get",
    params,
  });
}

//3-5 新增
export function addGovSystem(data) {
  return request({
    url: "/api/v1/governmentSystemDic/add",
    method: "post",
    data,
  });
}

//3-6 修改
export function updateGovSystem(data) {
  return request({
    url: "/api/v1/governmentSystemDic/update",
    method: "post",
    data,
  });
}

//3-7 详情
export function getGovSystemItem(params) {
  return request({
    url: `/api/v1/governmentSystemDics/${params.id}`,
    method: "get",
    params,
  });
}

//3-8 删除
export function deleteGovSystemItem(data) {
  return request({
    url: `/api/v1/governmentSystemDic/delete`,
    method: "delete",
    data,
  });
}

/*
4、签证审批
 */

// 4-1签证审批列表
export function getEmployeeVisaApplications(params) {
  return request({
    url: "/api/v1/employeeVisaApplications",
    method: "get",
    params,
  });
}

//4-2 新增签证审批表
export function addEmployeeVisaApplication(data) {
  return request({
    url: "/api/v1/employeeVisaApplication/add",
    method: "post",
    data,
  });
}

//4-3 签证审批表详情
export function getEmployeeVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//4-4 编辑签证审批表
export function editEmployeeVisaApplication(data) {
  return request({
    url: `/api/v1/employeeVisaApplication/edit`,
    method: "post",
    data,
  });
}

//4-5 编辑签证审批表
export function deleteEmployeeVisaApplication(params) {
  return request({
    url: `/api/v1/employeeVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 2-6 导出数据
export function exportEmployeeVisaApplication(params) {
  return request({
    url: "/api/v1/employeeVisaApplication/export",
    method: "get",
    params,
  });
}
/*
 5、员工邀请函 
*/
// 5-1 员工邀请函列表
export function getInvitationLetterApplications(params) {
  return request({
    url: "/api/v1/invitationLetterApplications",
    method: "get",
    params,
  });
}

// 5-2 新增员工邀请函
export function addInvitationLetterApplication(data) {
  return request({
    url: "/api/v1/invitationLetterApplication/add",
    method: "post",
    data,
  });
}

// 5-3 员工邀请函详情
export function getInvitationLetterApplicationItem(params) {
  return request({
    url: `/api/v1/invitationLetterApplications/${params.key}`,
    method: "get",
    params,
  });
}

//5-4 员工邀请函修改
export function updateInvitationLetterApplication(data) {
  return request({
    url: "/api/v1/invitationLetterApplication/edit",
    method: "post",
    data,
  });
}
// 5-5 删除
export function deleteInvitationLetterApplicationItem(params) {
  return request({
    url: `/api/v1/invitationLetterApplication/delete`,
    method: "delete",
    params,
  });
}

/*
6、签证审批台账
*/

// 6-1 获取签证审批台账列表
export function getEmployeeVisaHistories(params) {
  return request({
    url: "/api/v1/employeeVisaHistories",
    method: "get",
    params,
  });
}

// 6-2 导出签证审批台账列表
export function exportEmployeeVisaHistory(params) {
  return request({
    url: "/api/v1/employeeVisaHistory/export",
    method: "get",
    params,
  });
}

/* 
7、人员信息修改
*/

// 7-1 获取人员信息列表
export function getEmployeeInfoChangeApplications(params) {
  return request({
    url: "/api/v1/employeeInfoChangeApplications",
    method: "get",
    params,
  });
}
// 7-2 详情
export function getEmployeeInfoChangeApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeInfoChangeApplications/${params.id}`,
    method: "get",
    params,
  });
}

// 7-3 审核
export function auditEmployeeInfoChangeApplication(data) {
  return request({
    url: `/api/v1/employeeInfoChangeApplication/audit`,
    method: "post",
    data,
  });
}

/*
8 员工携带家属
*/

// 8-1 获取列表
export function getInvitationLetterApplication2s(params) {
  return request({
    url: "/api/v1/familyVisitVisaNvitationLetterApplications",
    method: "get",
    params,
  });
}

// 8-2 新增员工携带家属邀请函
export function addInvitationLetterApplication2(data) {
  return request({
    url: "/api/v1/familyVisitVisaNvitationLetterApplication/add",
    method: "post",
    data,
  });
}

// 8-3 详情
export function getInvitationLetterApplicationItem2(params) {
  return request({
    url: `/api/v1/familyVisitVisaNvitationLetterApplications/${params.key}`,
    method: "get",
    params,
  });
}

//8-4 编辑
export function editInvitationLetterApplicationItem2(data) {
  return request({
    url: `/api/v1/familyVisitVisaNvitationLetterApplication/edit`,
    method: "post",
    data,
  });
}

//8-5 删除
export function deleteInvitationLetterApplicationItem2(params) {
  return request({
    url: `/api/v1/familyVisitVisaNvitationLetterApplication/delete`,
    method: "delete",
    params,
  });
}

/*
9、不良人员
*/

// 9-1 不良人员列表
export function getBlacklists(params) {
  return request({
    url: "/api/v1/blacklists",
    method: "get",
    params,
  });
}

// 9-2 新增不良人员
export function addBlackItem(data) {
  return request({
    url: "/api/v1/blacklist/add",
    method: "post",
    data,
  });
}

//9-3 编辑不良人员
export function updateBlackItem(data) {
  return request({
    url: "/api/v1/blacklist/update",
    method: "post",
    data,
  });
}

//9-4 编辑不良人员
export function getBlackItem(params) {
  return request({
    url: `api/v1/blacklists/${params.id}`,
    method: "get",
    params,
  });
}

//9-5 下载机构资质导入模板
export function importBlacklistTemplate(params) {
  return request({
    url: "/api/v1/blacklist/import/template",
    method: "get",
    params,
  });
}

//9-6 导入模板
export function importBlacklist(data) {
  return request({
    url: "/api/v1/blacklist/import",
    method: "post",
    data,
  });
}
//9-7 导出
export function exportBlacklist(params) {
  return request({
    url: "/api/v1/blacklist/export",
    method: "get",
    params,
  });
}
//9-8 删除
export function deleteBlacklistItem(data) {
  return request({
    url: "/api/v1/blacklist/delete",
    method: "delete",
    data,
  });
}

/*
10、机票请购
*/

// 10-1 列表
export function getFlightTicketApplications(params) {
  return request({
    url: "/api/v1/employeeFlightTicketApplications",
    method: "get",
    params,
  });
}

export function getFlightTicketApplications2(params) {
  return request({
    url: "/api/v1/employee/employeeFlightTicketApplications",
    method: "get",
    params,
  });
}

//10-2 添加审批表
export function addFlightTicketApplication(data) {
  return request({
    url: "/api/v1/employeeFlightTicketApplication/add",
    method: "post",
    data,
  });
}

export function addFlightTicketApplication2(data) {
  return request({
    url: "/api/v1/employee/employeeFlightTicketApplication/add",
    method: "post",
    data,
  });
}

// 10-3 获取审批表详情
export function getFlightTicketApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeFlightTicketApplications/${params.key}`,
    method: "get",
    params,
  });
}

export function getFlightTicketApplicationsItem2(params) {
  return request({
    url: `/api/v1/employee/employeeFlightTicketApplications/${params.key}`,
    method: "get",
    params,
  });
}

// 10-4 修改审批表
export function editFlightTicketApplication(data) {
  return request({
    url: "/api/v1/employeeFlightTicketApplication/edit",
    method: "post",
    data,
  });
}

export function editFlightTicketApplication2(data) {
  return request({
    url: "/api/v1/employee/employeeFlightTicketApplication/edit",
    method: "post",
    data,
  });
}
// 10-5 删除审批表
export function deleteFlightTicketApplicationItem(params) {
  return request({
    url: "/api/v1/employeeFlightTicketApplication/delete",
    method: "delete",
    params,
  });
}
export function deleteFlightTicketApplicationItem2(params) {
  return request({
    url: "/api/v1/employee/employeeFlightTicketApplication/delete",
    method: "delete",
    params,
  });
}

export function getLeaveDayApplicationNumber(params) {
  return request({
    url: `/api/v1/employeeFlightTicketApplication/leaveDay/${params.applicationNumber}`,
    method: "get",
    params,
  });
}
// 10-6 修改外事关系
export function putEmployeeFlightTicketApplicationItem(data) {
  return request({
    url: `/api/v1/employeeFlightTicketApplication/put`,
    method: "post",
    data,
  });
}

//
export function getLeaveApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeFlightTicketApplication/leaveApplications/${params.number}`,
    method: "get",
    params,
  });
}

export function getverseasWorksApplicationsItem2(params) {
  return request({
    url: `/api/v1/employeeFlightTicketApplication/overseasWorksApplications/${params.number}`,
    method: "get",
    params,
  });
}

/*
11、机票变更
*/

// 11-1 列表
export function getFlightTicketReccheduleApplication(params) {
  return request({
    url: "/api/v1/flightTicketRescheduleApplication",
    method: "get",
    params,
  });
}

export function getFlightTicketReccheduleApplication2(params) {
  return request({
    url: "/api/v1/employee/flightTicketRescheduleApplications",
    method: "get",
    params,
  });
}

//11-2 获取本人最近一次机票
export function getLastestTicketBooking(params) {
  return request({
    url: `/api/v1/flightTicketRescheduleApplication/lastestTicketBooking/${params.ppCode}`,
    method: "get",
    params,
  });
}

//11-3 添加表单
export function addFlightTicketRescheduleApplication(data) {
  return request({
    url: `/api/v1/flightTicketRescheduleApplication/add`,
    method: "post",
    data,
  });
}
export function addFlightTicketRescheduleApplication2(data) {
  return request({
    url: `/api/v1/employee/flightTicketRescheduleApplication/add`,
    method: "post",
    data,
  });
}

//11-4 获取详情

export function getFlightTicketRescheduleApplicationItem(params) {
  return request({
    url: `/api/v1/flightTicketRescheduleApplications/${params.key}`,
    method: "get",
    params,
  });
}
export function getFlightTicketRescheduleApplicationItem2(params) {
  return request({
    url: `/api/v1/employee/flightTicketRescheduleApplications/${params.key}`,
    method: "get",
    params,
  });
}

//11-5 编辑
export function editFlightTicketRescheduleApplicationItem(data) {
  return request({
    url: `/api/v1/flightTicketRescheduleApplication/edit`,
    method: "post",
    data,
  });
}

export function editFlightTicketRescheduleApplicationItem2(data) {
  return request({
    url: `/api/v1/employee/flightTicketRescheduleApplication/edit`,
    method: "post",
    data,
  });
}

//11-6 删除
export function deleteFlightTicketRescheduleApplicationItem(params) {
  return request({
    url: `/api/v1/flightTicketRescheduleApplication/delete`,
    method: "delete",
    params,
  });
}
export function deleteFlightTicketRescheduleApplicationItem2(params) {
  return request({
    url: `/api/v1/employee/flightTicketRescheduleApplication/delete`,
    method: "delete",
    params,
  });
}
// 11-7 修改外事关系
export function putFlightTicketRescheduleApplicationItem(data) {
  return request({
    url: `/api/v1/flightTicketRescheduleApplication/put`,
    method: "post",
    data,
  });
}
/*
12、机票订购
*/
// 12-1 列表
export function getTicketBookings(data) {
  return request({
    url: "/api/v1/ticketBookings",
    method: "post",
    data,
  });
}

//12-2 编辑
export function editTicketBookingsItem(data) {
  return request({
    url: `/api/v1/ticketBooking/update`,
    method: "post",
    data,
  });
}

//12-3 获取详情
export function getTicketBookingsItem(params) {
  return request({
    url: `/api/v1/ticketBookings/${params.key}`,
    method: "get",
    params,
  });
}

//12-4 导入
export function importTicketBookings(data) {
  return request({
    url: `/api/v1/ticketBooking/import`,
    method: "post",
    data,
  });
}
//12-5 导出
export function exportTicketBookings(data) {
  return request({
    url: `/api/v1/ticketBooking/export`,
    method: "post",
    data,
  });
}

//12-6 导入模板
export function importTicketBookingsTemplate(params) {
  return request({
    url: `/api/v1/ticketBooking/import/template`,
    method: "get",
    params,
  });
}

//12-7 修改机票状态
export function updateTicketStatus(data) {
  return request({
    url: `/api/v1/ticketBooking/ticketStatus/update`,
    method: "post",
    data,
  });
}

/*
13、接送站
*/
// 13-1 列表
export function getDropOfforPickup(params) {
  return request({
    url: "/api/v1/dropOfforPickup",
    method: "get",
    params,
  });
}

/*
14、岗位类别
*/
//全部
export function getPositionCategoryAll(params) {
  return request({
    url: `/api/v1/positionCategory/all`,
    method: "get",
    params,
  });
}

// 14-1 列表
export function positionCategories(params) {
  return request({
    url: "/api/v1/positionCategories",
    method: "get",
    params,
  });
}

// 14-2 添加
export function addPositionCategory(data) {
  return request({
    url: "/api/v1/positionCategory/add",
    method: "post",
    data,
  });
}

// 14-3 编辑
export function updatePositionCategory(data) {
  return request({
    url: "/api/v1/positionCategory/update",
    method: "post",
    data,
  });
}

// 14-4 删除
export function deletePositionCategory(params) {
  return request({
    url: "/api/v1/positionCategory/delete",
    method: "delete",
    params,
  });
}

/*
15、当地岗位服务外包订单
*/
// 15-1 列表
export function getPurchaseOrderApplication(params) {
  return request({
    url: "/api/v1/purchaseOrderApplication",
    method: "get",
    params,
  });
}

// 15-2
export function getPurchaseOrderApplicationSuppliers(params) {
  return request({
    url: "/api/v1/purchaseOrderApplication/suppliers",
    method: "get",
    params,
  });
}

// 15-3 新增
export function addPurchaseOrderApplication(data) {
  return request({
    url: "/api/v1/purchaseOrderApplication/add",
    method: "post",
    data,
  });
}

// 15-4 详情
export function getPurchaseOrderApplicationItem(params) {
  return request({
    url: `/api/v1/purchaseOrderApplications/${params.key}`,
    method: "get",
    params,
  });
}

//15-5 修改
export function editPurchaseOrderApplication(data) {
  return request({
    url: "/api/v1/purchaseOrderApplication/edit",
    method: "post",
    data,
  });
}

//15-6 删除
export function deltePurchaseOrderApplication(params) {
  return request({
    url: "/api/v1/purchaseOrderApplication/delete",
    method: "delete",
    params,
  });
}

// 15-7 依赖数据
export function getPurchaseOrderApplicationOrders(params) {
  return request({
    url: "/api/v1/purchaseOrderApplication/orders",
    method: "get",
    params,
  });
}

/*
16、订单数据库
*/

// 16-1 列表
export function getPurchaseOrderAccountings(params) {
  return request({
    url: "/api/v1/purchaseOrderAccountings",
    method: "get",
    params,
  });
}

// 16-2 导出
export function exportPurchaseOrderAccountings(params) {
  return request({
    url: "/api/v1/purchaseOrderAccounting/export",
    method: "get",
    params,
  });
}

/*
17、当地岗位服务外包单位档案管理 
*/

// 17-1 列表
export function getManpowerSupplierList(params) {
  return request({
    url: "/api/v1/manpowerSupplierList",
    method: "get",
    params,
  });
}
// 17-2 新增
export function addManpowerSupplierListItem(data) {
  return request({
    url: "/api/v1/manpowerSupplierList/add",
    method: "post",
    data,
  });
}

//17-3 删除
export function deleteManpowerSupplierListItem(params) {
  return request({
    url: "/api/v1/manpowerSupplierList/delete",
    method: "delete",
    params,
  });
}
// 17-4 详情
export function getManpowerSupplierListItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierList/${params.key}`,
    method: "get",
    params,
  });
}
//17-5 编辑
export function editManpowerSupplierListItem(data) {
  return request({
    url: `/api/v1/manpowerSupplierList/edit`,
    method: "post",
    data,
  });
}

//17-6 导入模板
export function getManpowerSupplierListTemplate(params) {
  return request({
    url: `/api/v1/manpowerSupplierList/import/template`,
    method: "get",
    params,
  });
}

//17-7 导入
export function importManpowerSupplierListTemplate(data) {
  return request({
    url: `/api/v1/manpowerSupplierList/import`,
    method: "post",
    data,
  });
}

//17-8 导出
export function exportManpowerSupplierListTemplate(params) {
  return request({
    url: `/api/v1/manpowerSupplierList/export`,
    method: "get",
    params,
  });
}

/*
18、续签管理
*/
// 18-1 列表
export function getManpowerSupplierAssessments(params) {
  return request({
    url: "/api/v1/manpowerSupplierAssessments",
    method: "get",
    params,
  });
}

// 18-2 添加
export function addManpowerSupplierAssessmentsItem(data) {
  return request({
    url: "/api/v1/manpowerSupplierAssessment/add",
    method: "post",
    data,
  });
}

// 18-3 详情
export function getManpowerSupplierAssessmentsItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierAssessments/${params.key}`,
    method: "get",
    params,
  });
}

// 18-4 编辑
export function editManpowerSupplierAssessmentsItem(data) {
  return request({
    url: `/api/v1/manpowerSupplierAssessment/edit`,
    method: "post",
    data,
  });
}
// 18-5 删除
export function deleteManpowerSupplierAssessmentsItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierAssessment/delete`,
    method: "delete",
    params,
  });
}

// 18-6 导入
export function importManpowerSupplierAssessment(data) {
  return request({
    url: `/api/v1/manpowerSupplierAssessment/import`,
    method: "post",
    data,
  });
}

// 18-7 导入模板
export function getManpowerSupplierAssessmentTemplate(params) {
  return request({
    url: `/api/v1/manpowerSupplierAssessment/import/template`,
    method: "get",
    params,
  });
}

/*
19、奖惩管理
*/
// 19-1 列表
export function getManpowerSupplierPunishmentAndRewards(params) {
  return request({
    url: "/api/v1/manpowerSupplierRewardAndDisciplines",
    method: "get",
    params,
  });
}

// 19-2 添加
export function addManpowerSupplierPunishmentAndReward(data) {
  return request({
    url: "/api/v1/manpowerSupplierRewardAndDiscipline/add",
    method: "post",
    data,
  });
}

// 19-3 详情
export function getManpowerSupplierPunishmentAndRewardsItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierRewardAndDisciplines/${params.key}`,
    method: "get",
    params,
  });
}

//19-4 修改
export function editManpowerSupplierPunishmentAndReward(data) {
  return request({
    url: "/api/v1/manpowerSupplierRewardAndDiscipline/edit",
    method: "post",
    data,
  });
}

// 19-5 删除

export function deleteManpowerSupplierPunishmentAndRewardItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierRewardAndDiscipline/delete`,
    method: "delete",
    params,
  });
}

// 19-6 导入
export function importmanpowerSupplierPunishmentAndReward(data) {
  return request({
    url: `/api/v1/manpowerSupplierRewardAndDiscipline/import`,
    method: "post",
    data,
  });
}

// 19-7 导入模板
export function getManpowerSupplierPunishmentAndRewardTemplate(params) {
  return request({
    url: `/api/v1/manpowerSupplierRewardAndDiscipline/import/template`,
    method: "get",
    params,
  });
}

/*
20、机票费用
*/

// 20-1 列表
export function getTicketFares(data) {
  return request({
    url: "/api/v1/ticketFares",
    method: "post",
    data,
  });
}

//20-2 编辑
export function editTicketFareItem(data) {
  return request({
    url: `/api/v1/ticketFare/update`,
    method: "post",
    data,
  });
}

//20-3 获取详情
export function getTicketFaresItem(params) {
  return request({
    url: `/api/v1/ticketFares/${params.key}`,
    method: "get",
    params,
  });
}

//20-4 导入
export function importTicketFare(data) {
  return request({
    url: `/api/v1/ticketFare/import`,
    method: "post",
    data,
  });
}
//20-5 导出
export function exportTicketFare(data) {
  return request({
    url: `/api/v1/ticketFare/export`,
    method: "post",
    data,
  });
}

//20-6 导入模板
export function importTicketFareTemplate(params) {
  return request({
    url: `/api/v1/ticketFare/import/template`,
    method: "get",
    params,
  });
}

/*
21、当地岗位服务外包费明细
*/
// 21-1 列表
export function getManpowerSupplierMonthlyCostAccountings(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostAccountings",
    method: "get",
    params,
  });
}

// 21-2 导出
export function exportManpowerSupplierMonthlyCostAccountings(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostAccounting/export",
    method: "get",
    params,
  });
}

/*
22、飞行路线
*/
// 22-1 列表
export function getAirlines(params) {
  return request({
    url: "/api/v1/airlines",
    method: "get",
    params,
  });
}
// 22-2 新增
export function addAirlines(data) {
  return request({
    url: "/api/v1/airline/add",
    method: "post",
    data,
  });
}
// 22-3 详情
export function getAirlinesItem(params) {
  return request({
    url: `/api/v1/airlines/${params.id}`,
    method: "get",
    params,
  });
}
// 22-4 修改
export function updateAirlines(data) {
  return request({
    url: "/api/v1/airline/update",
    method: "post",
    data,
  });
}
// 22-5 删除
export function deleteAirlines(data) {
  return request({
    url: "/api/v1/airline/delete",
    method: "delete",
    data,
  });
}

//导入
export function importAirline(data) {
  return request({
    url: "/api/v1/airline/import",
    method: "post",
    data,
  });
}

//导出
export function exportAirline(params) {
  return request({
    url: "/api/v1/airline/export",
    method: "get",
    params,
  });
}

//下载
export function templateAirline(params) {
  return request({
    url: "/api/v1/airline/import/template",
    method: "get",
    params,
  });
}

/*
23、月度挂账管理
*/
// 23-1 列表
export function getManpowerSupplierMonthlyCostApplicationDetailAccountings(
  params,
) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplicationDetailAccountings",
    method: "get",
    params,
  });
}

// 23-2 导出
export function exportManpowerSupplierMonthlyCostApplicationDetailAccountings(
  params,
) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplicationDetailAccounting/export",
    method: "get",
    params,
  });
}

/*
24、当地岗位服务费月度挂账
*/

// 24-1 列表
export function getManpowerSupplierMonthlyCostApplicationDetails(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplicationDetails",
    method: "get",
    params,
  });
}

//24-2 导入模板
export function importManpowerSupplierMonthlyCostDetailTemplate(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostDetail/import/template",
    method: "get",
    params,
  });
}

//24-3 新增
export function addManpowerSupplierMonthlyCostApplicationDetail(data) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplicationDetail/add",
    method: "post",
    data,
  });
}

// 24-4 编辑
export function editManpowerSupplierMonthlyCostApplicationDetail(data) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplicationDetail/edit",
    method: "post",
    data,
  });
}

// 24-5 删除
export function deleteManpowerSupplierMonthlyCostApplicationDetail(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplicationDetail/delete",
    method: "delete",
    params,
  });
}

// 24-6 添加审批表
export function addManpowerSupplierMonthlyCostApplication(data) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplication/add",
    method: "post",
    data,
  });
}

// 24-7 明细列表
export function getManpowerSupplierMonthlyCostDetails(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostDetails",
    method: "get",
    params,
  });
}

// 24-8 详情
export function getManpowerSupplierMonthlyCostApplicationDetailsItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplicationDetails/${params.key}`,
    method: "get",
    params,
  });
}

export function getManpowerSupplierMonthlyCostApplicationCostDetails(params) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplicationDetail/costDetails`,
    method: "get",
    params,
  });
}

// 24-9 修改付款方式
export function putManpowerSupplierMonthlyCostApplicationDetail(data) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplicationDetail/put`,
    method: "post",
    data,
  });
}
//修改币种
export function putManpowerSupplierMonthlyCostApplicationDetailCurrency(data) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplicationDetail/currency/put`,
    method: "post",
    data,
  });
}

// 明细删除

export function deleteManpowerSupplierMonthlyCostApplicationDetailDetail(data) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplicationDetail/detail/delete`,
    method: "delete",
    data,
  });
}

//获取全部详情
export function allManpowerSupplierMonthlyCostApplicationDetails(data) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplicationDetails/all`,
    method: "post",
    data,
  });
}

// 月度挂账审批相关

//列表
export function getManpowerSupplierMonthlyCostApplications(params) {
  return request({
    url: "/api/v1/manpowerSupplierMonthlyCostApplications2",
    method: "get",
    params,
  });
}

// 详情
export function getManpowerSupplierMonthlyCostApplicationsItem(params) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplications/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deleteManpowerSupplierMonthlyCostApplication(params) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplication/delete`,
    method: "delete",
    params,
  });
}

//编辑
export function editManpowerSupplierMonthlyCostApplication(data) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplication/edit`,
    method: "post",
    data,
  });
}

//获取可加入的审批表
export function pendingManpowerSupplierMonthlyCostApplication(params) {
  return request({
    url: `/api/v1/manpowerSupplierMonthlyCostApplications/pending`,
    method: "get",
    params,
  });
}

/*
25、内部借工协议
*/
// 25-1 列表

export function getInternalTemporaryManpowerApplications(params) {
  return request({
    url: "/api/v1/internalTemporaryManpowerApplications",
    method: "get",
    params,
  });
}

// 25-2 添加
export function addInternalTemporaryManpowerApplication(data) {
  return request({
    url: "/api/v1/internalTemporaryManpowerApplication/add",
    method: "post",
    data,
  });
}

//25-3 详情
export function getInternalTemporaryManpowerApplicationsItem(params) {
  return request({
    url: `/api/v1/internalTemporaryManpowerApplications/${params.key}`,
    method: "get",
    params,
  });
}

//25-4 编辑
export function editInternalTemporaryManpowerApplicationsItem(data) {
  return request({
    url: `/api/v1/internalTemporaryManpowerApplication/edit`,
    method: "post",
    data,
  });
}

// 25-5 删除
export function deleteInternalTemporaryManpowerApplicationsItem(params) {
  return request({
    url: `/api/v1/internalTemporaryManpowerApplication/delete`,
    method: "delete",
    params,
  });
}

/*
26、出国(境)任务
*/

// 26-1 列表
export function getOverseasWorksApplications(params) {
  return request({
    url: "/api/v1/overseasWorksApplications",
    method: "get",
    params,
  });
}

// 26-2 新增
export function addOverseasWorksApplication(data) {
  return request({
    url: "/api/v1/overseasWorksApplication/add",
    method: "post",
    data,
  });
}

// 26-3 详情
export function getOverseasWorksApplicationsItem(params) {
  return request({
    url: `/api/v1/overseasWorksApplications/${params.key}`,
    method: "get",
    params,
  });
}

// 26-4 编辑
export function editOverseasWorksApplicationsItem(data) {
  return request({
    url: `/api/v1/overseasWorksApplication/edit`,
    method: "post",
    data,
  });
}

// 26-5 删除
export function deleteOverseasWorksApplicationsItem(params) {
  return request({
    url: `/api/v1/overseasWorksApplication/delete`,
    method: "delete",
    params,
  });
}
/*
27、境外公共安全培训
*/

// 27-1 列表
export function getRegistrationforPublicSafetyTrainingApplications(params) {
  return request({
    url: "/api/v1/registrationforPublicSafetyTrainingApplications2",
    method: "get",
    params,
  });
}

// 27-2 新增
export function addRegistrationforPublicSafetyTrainingApplication(data) {
  return request({
    url: "/api/v1/registrationforPublicSafetyTrainingApplication/add",
    method: "post",
    data,
  });
}

// 27-3 详情
export function getRegistrationforPublicSafetyTrainingApplicationsItem(params) {
  return request({
    url: `/api/v1/registrationforPublicSafetyTrainingApplications/${params.key}`,
    method: "get",
    params,
  });
}

// 27-4 编辑
export function editRegistrationforPublicSafetyTrainingApplicationItem(data) {
  return request({
    url: `/api/v1/registrationforPublicSafetyTrainingApplication/edit`,
    method: "post",
    data,
  });
}

// 27-5 删除
export function deleteRegistrationforPublicSafetyTrainingApplicationItem(
  params,
) {
  return request({
    url: `/api/v1/registrationforPublicSafetyTrainingApplication/delete`,
    method: "delete",
    params,
  });
}

// 27-6 获取最近一次培训记录
export function getTrainings(params) {
  return request({
    url: `/api/v1/registrationforPublicSafetyTrainingApplication/trainings`,
    method: "get",
    params,
  });
}

/*
28、国家地区管理
*/

// 28-1 列表
export function getCountries(params) {
  return request({
    url: "/api/v1/countries",
    method: "get",
    params,
  });
}

// 28-2 新增
export function addCountries(data) {
  return request({
    url: "/api/v1/country/add",
    method: "post",
    data,
  });
}

// 28-3 修改
export function updateCountries(data) {
  return request({
    url: "/api/v1/country/update",
    method: "post",
    data,
  });
}

//28-4 删除
export function deleteCountries(data) {
  return request({
    url: "/api/v1/country/delete",
    method: "delete",
    data,
  });
}

//28-5 详情
export function getCountriesItem(params) {
  return request({
    url: `/api/v1/countries/${params.id}`,
    method: "get",
    params,
  });
}

//28-6 获取全部城市
export function allCountry(params) {
  return request({
    url: `/api/v1/country/all`,
    method: "get",
    params,
  });
}

/*
29、城市管理
*/
// 29-1 列表
export function getCities(params) {
  return request({
    url: "/api/v1/cities",
    method: "get",
    params,
  });
}

// 29-2 新增
export function addCities(data) {
  return request({
    url: "/api/v1/city/add",
    method: "post",
    data,
  });
}

// 29-3 修改
export function updateCities(data) {
  return request({
    url: "/api/v1/city/update",
    method: "post",
    data,
  });
}

//29-4 删除
export function deleteCities(data) {
  return request({
    url: "/api/v1/city/delete",
    method: "delete",
    data,
  });
}

//29-5 详情
export function getCitiesItem(params) {
  return request({
    url: `/api/v1/cities/${params.id}`,
    method: "get",
    params,
  });
}

//29-6 获取全部城市
export function allCities(params) {
  return request({
    url: `/api/v1/city/all`,
    method: "get",
    params,
  });
}

/*
30、境外公共安全培训台账
*/

// 30-1 列表
export function getRegistrationforPublicSafetyTrainingAccountings(params) {
  return request({
    url: `/api/v1/registrationforPublicSafetyTrainingAccountings`,
    method: "get",
    params,
  });
}

//30-2 导出
export function exportRegistrationforPublicSafetyTrainingAccounting(params) {
  return request({
    url: `/api/v1/registrationforPublicSafetyTrainingAccounting/export`,
    method: "get",
    params,
  });
}

/*
31、SPONSOR转入/转出
*/
// 31-1 列表
export function getTransferSponsorApplications2(params) {
  return request({
    url: `/api/v1/transferSponsorApplications2`,
    method: "get",
    params,
  });
}

// 31-2 新增
export function addTransferSponsorApplication(data) {
  return request({
    url: `/api/v1/transferSponsorApplication/add`,
    method: "post",
    data,
  });
}

//31-3 详情
export function getTransferSponsorApplicationsItem(params) {
  return request({
    url: `/api/v1/transferSponsorApplications/${params.key}`,
    method: "get",
    params,
  });
}

//31-4 编辑
export function editTransferSponsorApplications(data) {
  return request({
    url: `/api/v1/transferSponsorApplication/edit`,
    method: "post",
    data,
  });
}

//31-5 删除
export function deleteTransferSponsorApplications(params) {
  return request({
    url: `/api/v1/transferSponsorApplication/delete`,
    method: "delete",
    params,
  });
}

//付费
export function payTransferSponsorApplication(data) {
  return request({
    url: `/api/v1/transferSponsorApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeTransferSponsorApplication(data) {
  return request({
    url: `/api/v1/transferSponsorApplication/complete`,
    method: "post",
    data,
  });
}

/*
32、第三国签证申请
*/
// 32-1 列表
export function getVistVisaofNonWorkingCountryApplications2(params) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplications2`,
    method: "get",
    params,
  });
}

// 32-2 新增
export function addVistVisaofNonWorkingCountryApplication(data) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplication/add`,
    method: "post",
    data,
  });
}

//32-3 详情
export function getVistVisaofNonWorkingCountryApplicationsItem(params) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplications/${params.key}`,
    method: "get",
    params,
  });
}

//32-4 编辑
export function editVistVisaofNonWorkingCountryApplication(data) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplication/edit`,
    method: "post",
    data,
  });
}

//32-5 删除
export function deleteVistVisaofNonWorkingCountryApplication(params) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplication/delete`,
    method: "delete",
    params,
  });
}

//付费
export function payVistNonWorkingCountryApplication(data) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeVistNonWorkingCountryApplication(data) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplication/complete`,
    method: "post",
    data,
  });
}

/*
33、签证状态跟踪(赴沙)管理  
WorkVisaTracking 
*/

// 33-1 列表
export function getRecordforVisas(params) {
  return request({
    url: `/api/v1/workVisaTrackings`,
    method: "get",
    params,
  });
}

// 33-2 导出
export function exportRecordforVisas(params) {
  return request({
    url: `/api/v1/workVisaTracking/export`,
    method: "get",
    params,
  });
}

//33-3 详情
export function getRecordforVisasItem(params) {
  return request({
    url: `/api/v1/workVisaTrackings/${params.key}`,
    method: "get",
    params,
  });
}

// 33-4 更新
export function updateRecordforVisa(data) {
  return request({
    url: `/api/v1/workVisaTracking/update`,
    method: "post",
    data,
  });
}

// 33-4 更新1
export function updateRecordforVisa1(data) {
  return request({
    url: `/api/v1/workVisaTracking/documents/update`,
    method: "post",
    data,
  });
}

// 33-5 更新2
export function updateRecordforVisa2(data) {
  return request({
    url: `/api/v1/workVisaTracking/visaInfo/update`,
    method: "post",
    data,
  });
}
// 33-6 更新3
export function updateRecordforVisa3(data) {
  return request({
    url: `/api/v1/workVisaTracking/remark/update`,
    method: "post",
    data,
  });
}

export function processRecordforVisa(data) {
  return request({
    url: `/api/v1/workVisaTracking/process`,
    method: "post",
    data,
  });
}

//导入
export function importRecordforVisa(data) {
  return request({
    url: `/api/v1/workVisaTracking/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateRecordforVisa(params) {
  return request({
    url: `/api/v1/workVisaTracking/import/template`,
    method: "get",
    params,
  });
}

//上传签证
export function updateRecordforVisaUrl(data) {
  return request({
    url: `/api/v1/workVisaTracking/update`,
    method: "post",
    data,
  });
}

export function docRecognitionRecordforVisa(data) {
  return request({
    url: `/api/v1/workVisaTracking/DocRecognition`,
    method: "post",
    data,
  });
}

export function ticketRecordforVisa(params) {
  return request({
    url: `/api/v1/workVisaTracking/tickets`,
    method: "get",
    params,
  });
}

export function flightTicketRecordforVisa(data) {
  return request({
    url: `/api/v1/workVisaTracking/flightTicket/update`,
    method: "post",
    data,
  });
}

export function setRecordforVisa(data) {
  return request({
    url: `/api/v1/workVisaTracking/warning/set`,
    method: "post",
    data,
  });
}

/*
34、签证状态跟踪(离沙)管理 
*/

// 34-1 列表
export function getVisaRecordofBusinesses(params) {
  return request({
    url: `/api/v1/visaRecordofBusinesses`,
    method: "get",
    params,
  });
}

// 34-2 导出
export function exportVisaRecordofBusinesses(params) {
  return request({
    url: `/api/v1/visaRecordofBusinesses/export`,
    method: "get",
    params,
  });
}

//34-3 详情
export function getVisaRecordofBusinessesItem(params) {
  return request({
    url: `/api/v1/visaRecordofBusinesses/${params.key}`,
    method: "get",
    params,
  });
}

// 34-4 更新1
export function updateVisaRecordofBusiness(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/update`,
    method: "post",
    data,
  });
}

// 34-4 更新1
export function updateVisaRecordofBusiness1(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/foreignAffairsStatus/update`,
    method: "post",
    data,
  });
}

// 34-5 更新2
export function updateVisaRecordofBusiness2(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/businessTripApplicationNumber/update`,
    method: "post",
    data,
  });
}
//34-6 更新3
export function updateVisaRecordofBusiness3(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/overseasMission/update`,
    method: "post",
    data,
  });
}
//34-7 更新4
export function updateVisaRecordofBusiness4(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/documents/update`,
    method: "post",
    data,
  });
}
//34-8 更新5
export function updateVisaRecordofBusiness5(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/visaInfo/update`,
    method: "post",
    data,
  });
}
//34-9 更新6
export function updateVisaRecordofBusiness6(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/remark/update`,
    method: "post",
    data,
  });
}
//34-10 更新7
export function updateVisaRecordofBusiness7(data) {
  return request({
    url: `/api/v1/visaRecordofBusiness/usageVisaInfo/update`,
    method: "post",
    data,
  });
}

/*
35、签证预警管理
*/
// 35-1 列表
export function getVisaWarnings(params) {
  return request({
    url: `/api/v1/visaWarnings`,
    method: "get",
    params,
  });
}

/*
36、系统优化意见建议
 */

// 36-1 列表
export function getFeedbacks(params) {
  return request({
    url: `/api/v1/feedbacks`,
    method: "get",
    params,
  });
}

export function getFeedbacks2(params) {
  return request({
    url: `/api/v1/employee/feedbacks`,
    method: "get",
    params,
  });
}

// 36-2 新建
export function addFeedback(data) {
  return request({
    url: `/api/v1/feedback/add`,
    method: "post",
    data,
  });
}
export function addFeedback2(data) {
  return request({
    url: `/api/v1/employee/feedback/add`,
    method: "post",
    data,
  });
}
// 36-3 详情
export function getFeedbacksItem(params) {
  return request({
    url: `/api/v1/feedbacks/${params.id}`,
    method: "get",
    params,
  });
}
export function getFeedbacksItem2(params) {
  return request({
    url: `/api/v1/employee/feedbacks/${params.id}`,
    method: "get",
    params,
  });
}
// 36-4 编辑
export function updateFeedback(data) {
  return request({
    url: `/api/v1/feedback/update`,
    method: "post",
    data,
  });
}
export function updateFeedback2(data) {
  return request({
    url: `/api/v1/employee/feedback/update`,
    method: "post",
    data,
  });
}
// 36-5 删除
export function deleteFeedback(data) {
  return request({
    url: `/api/v1/feedback/delete`,
    method: "delete",
    data,
  });
}
export function deleteFeedback2(data) {
  return request({
    url: `/api/v1/employee/feedback/delete`,
    method: "delete",
    data,
  });
}
/*
 37、外国人访华业务审批
*/
// 37-1 列表
export function getInvitationLetterApplications22(params) {
  return request({
    url: "/api/v1/invitationLetterApplication2s",
    method: "get",
    params,
  });
}

// 37-2 新增
export function addInvitationLetterApplication22(data) {
  return request({
    url: "/api/v1/invitationLetterApplication2/add",
    method: "post",
    data,
  });
}

// 37-3 详情
export function getInvitationLetterApplicationItem22(params) {
  return request({
    url: `/api/v1/invitationLetterApplication2s/${params.key}`,
    method: "get",
    params,
  });
}

//37-4修改
export function updateInvitationLetterApplication22(data) {
  return request({
    url: "/api/v1/invitationLetterApplication2/edit",
    method: "post",
    data,
  });
}
// 37-5 删除
export function deleteInvitationLetterApplicationItem22(params) {
  return request({
    url: `/api/v1/invitationLetterApplication2/delete`,
    method: "delete",
    params,
  });
}

/*
 38、员工医保等级管理
*/

// 38-1 列表
export function getEmployeeMedicalInsuranceClassLevels(params) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceClassLevels",
    method: "get",
    params,
  });
}

// 38-2 新增
export function addEmployeeMedicalInsuranceClassLevel(data) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceClassLevel/add",
    method: "post",
    data,
  });
}

// 38-3 编辑
export function updateEmployeeMedicalInsuranceClassLevel(data) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceClassLevel/update",
    method: "post",
    data,
  });
}

// 38-4 详情
export function getEmployeeMedicalInsuranceClassLevelsItem(params) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceClassLevels/${params.id}`,
    method: "get",
    params,
  });
}

// 38-5 删除
export function deleteEmployeeMedicalInsuranceClassLevelsItem(data) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceClassLevel/delete`,
    method: "delete",
    data,
  });
}

// 38-6 获取全部
export function getEmployeeMedicalInsuranceClassLevelsAll(params) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceClassLevel/all`,
    method: "get",
    params,
  });
}
/*
 39、员工医疗保险注册
*/

// 39-1 列表
export function getEmployeeMedicalInsuranceRegistrationApplications2(params) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceRegistrationApplications2",
    method: "get",
    params,
  });
}

// 39-2 新增
export function addEmployeeMedicalInsuranceRegistrationApplication(data) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceRegistrationApplication/add",
    method: "post",
    data,
  });
}

// 39-3 编辑
export function updateEmployeeMedicalInsuranceRegistrationApplication(data) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceRegistrationApplication/edit",
    method: "post",
    data,
  });
}

// 39-4 详情
export function getEmployeeMedicalInsuranceRegistrationApplicationsItem(
  params,
) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceRegistrationApplications/${params.key}`,
    method: "get",
    params,
  });
}

// 39-5 删除
export function deletEemployeeMedicalInsuranceRegistrationApplicationItem(
  params,
) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceRegistrationApplication/delete`,
    method: "delete",
    params,
  });
}

/*
 40、员工医保变更
*/

// 40-1 列表
export function getEmployeeMedicalInsuranceAdjustmentmentApplications(params) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceAdjustmentmentApplications",
    method: "get",
    params,
  });
}

// 40-2 新增
export function addEmployeeMedicalInsuranceAdjustmentmentApplication(data) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceAdjustmentmentApplication/add",
    method: "post",
    data,
  });
}

// 40-3 编辑
export function updatEemployeeMedicalInsuranceAdjustmentmentApplication(data) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceAdjustmentmentApplication/edit",
    method: "post",
    data,
  });
}

// 40-4 详情
export function getEmployeeMedicalInsuranceAdjustmentmentApplicationsItem(
  params,
) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceAdjustmentmentApplications/${params.key}`,
    method: "get",
    params,
  });
}

// 40-5 删除
export function deleteEployeeMedicalInsuranceAdjustmentmentApplicationItem(
  params,
) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceAdjustmentmentApplication/delete`,
    method: "delete",
    params,
  });
}

/*
41、医保购买或台账
*/
// 41-1 列表
export function getEmployeeMedicalInsuranceRecords(params) {
  return request({
    url: "/api/v1/employeeMedicalInsuranceRecords",
    method: "get",
    params,
  });
}

// 41-2 获取列表子项目
export function getEmployeeMedicalInsuranceRecordsChildren(params) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceRecords/${params.key}/children`,
    method: "get",
    params,
  });
}

// 41-3 删除
export function deleteEmployeeMedicalInsuranceRecordsChildren(params) {
  return request({
    url: `/api/v1/EmployeeMedicalInsuranceRecords/delete`,
    method: "delete",
    params,
  });
}

// 41-4 导入模板
export function getEmployeeMedicalInsuranceRecordsTemplate(params) {
  return request({
    url: `/api/v1/EmployeeMedicalInsuranceRecords/import/template`,
    method: "get",
    params,
  });
}
// 41-5 导入
export function importEmployeeMedicalInsuranceRecords(data) {
  return request({
    url: `/api/v1/EmployeeMedicalInsuranceRecords/import`,
    method: "post",
    data,
  });
}

// 41-6 导出
export function exportEmployeeMedicalInsuranceRecords(params) {
  return request({
    url: `/api/v1/EmployeeMedicalInsuranceRecords/export`,
    method: "get",
    params,
  });
}

export function getEmployeeMedicalInsuranceRecordsItem(params) {
  return request({
    url: `/api/v1/employeeMedicalInsuranceRecords/${params.key}`,
    method: "get",
    params,
  });
}

export function editEmployeeMedicalInsuranceRecords(data) {
  return request({
    url: `/api/v1/EmployeeMedicalInsuranceRecords/edit`,
    method: "post",
    data,
  });
}

/*
42、因公临时出国(境)出行情况
*/

// 42-1 列表
export function getOverseasWorksAccountings(params) {
  return request({
    url: "/api/v1/overseasWorksAccountings",
    method: "get",
    params,
  });
}

// 42-2 修改
export function updateOverseasWorksAccounting(data) {
  return request({
    url: "/api/v1/overseasWorksAccounting/dateAndDays/update",
    method: "post",
    data,
  });
}

//导出
export function exportOverseasWorksAccounting(params) {
  return request({
    url: "/api/v1/overseasWorksAccounting/export",
    method: "get",
    params,
  });
}

/*
43、签证指标相关管理
*/

// 43-1 列表
export function getWorkVisaApplications2(params) {
  return request({
    url: "/api/v1/workVisaApplications2",
    method: "get",
    params,
  });
}

// 43-2 添加
export function addWorkVisaApplication(data) {
  return request({
    url: "/api/v1/workVisaApplication/add",
    method: "post",
    data,
  });
}

// 43-3 详情
export function getWorkVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/workVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

// 43-4 更新
export function editWorkVisaApplication(data) {
  return request({
    url: "/api/v1/workVisaApplication/edit",
    method: "post",
    data,
  });
}

// 43-5 删除
export function deleteWorkVisaApplication(params) {
  return request({
    url: "/api/v1/workVisaApplication/delete",
    method: "delete",
    params,
  });
}

/*
44、员工岗位变动
*/

// 44-1、列表
export function getPositionAdjustmentApplicantions(params) {
  return request({
    url: "/api/v1/positionAdjustmentApplicantions",
    method: "get",
    params,
  });
}

export function getPositionAdjustmentApplicantions2(params) {
  return request({
    url: "/api/v1/employee/positionAdjustmentApplicantions",
    method: "get",
    params,
  });
}

// 44-2、详情
export function getPositionAdjustmentApplicantionsItem(params) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantions/${params.key}`,
    method: "get",
    params,
  });
}
export function getPositionAdjustmentApplicantionsItem2(params) {
  return request({
    url: `/api/v1/employee/positionAdjustmentApplicantions/{${params.key}`,
    method: "get",
    params,
  });
}
// 44-3、删除
export function deletePositionAdjustmentApplicantionsItem(params) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantion/delete`,
    method: "delete",
    params,
  });
}
export function deletePositionAdjustmentApplicantionsItem2(params) {
  return request({
    url: `/api/v1/employee/positionAdjustmentApplicantion/delete`,
    method: "delete",
    params,
  });
}
// 44-4、添加
export function addPositionAdjustmentApplicantions(data) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantion/add`,
    method: "post",
    data,
  });
}
export function addPositionAdjustmentApplicantions2(data) {
  return request({
    url: `/api/v1/employee/positionAdjustmentApplicantion/add`,
    method: "post",
    data,
  });
}
// 44-5、编辑
export function editPositionAdjustmentApplicantions(data) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantion/edit`,
    method: "post",
    data,
  });
}
export function editPositionAdjustmentApplicantions2(data) {
  return request({
    url: `/api/v1/employee/positionAdjustmentApplicantion/edit`,
    method: "post",
    data,
  });
}
// 获取所有用工形式
export function getEmploymentFormAll(params) {
  return request({
    url: `/api/v1/employmentForm/all`,
    method: "get",
    params,
  });
}

// 获取所有岗位等级
export function getPositionLevelAll(params) {
  return request({
    url: `/api/v1/positionLevel/all`,
    method: "get",
    params,
  });
}

/*
45、员工岗位变动批量调整管理 
 */
// 45-1 列表
export function getPositionAdjustmentApplicantionOfflines(params) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantionOfflines`,
    method: "get",
    params,
  });
}

//45-2 导入模板
export function getPositionAdjustmentApplicantionOfflinesTemplate(params) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantionOffline/import/template`,
    method: "get",
    params,
  });
}

//45-3 导入
export function importPositionAdjustmentApplicantion(data) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantion/import`,
    method: "post",
    data,
  });
}

//45-4 删除
export function deletePositionAdjustmentApplicantionOffline(params) {
  return request({
    url: `/api/v1/positionAdjustmentApplicantionOffline/delete`,
    method: "delete",
    params,
  });
}

// 46、新办Iqama

// 46-1 列表
export function getNewIqamaApplications2(params) {
  return request({
    url: `/api/v1/newIqamaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addNewIqamaApplication(data) {
  return request({
    url: `/api/v1/newIqamaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editNewIqamaApplication(data) {
  return request({
    url: `/api/v1/newIqamaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getNewIqamaApplicationsItem(params) {
  return request({
    url: `/api/v1/newIqamaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payNewIqamaApplications(data) {
  return request({
    url: `/api/v1/newIqamaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeNewIqamaApplications(data) {
  return request({
    url: `/api/v1/newIqamaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteNewIqamaApplication(params) {
  return request({
    url: `/api/v1/newIqamaApplication/delete`,
    method: "delete",
    params,
  });
}

//导出
export function exportNewIqamaApplication(params) {
  return request({
    url: `/api/v1/newIqamaApplication/export`,
    method: "get",
    params,
  });
}

//导入
export function importNewIqamaApplication(data) {
  return request({
    url: `/api/v1/newIqamaApplication/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateNewIqamaApplication(params) {
  return request({
    url: `/api/v1/newIqamaApplication/import/template`,
    method: "get",
    params,
  });
}

// 47、延期Iqama

// 47-1 列表
export function getRenewIqamaApplications2(params) {
  return request({
    url: `/api/v1/renewIqamaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addRenewIqamaApplication(data) {
  return request({
    url: `/api/v1/renewIqamaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editRenewIqamaApplication(data) {
  return request({
    url: `/api/v1/renewIqamaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getRenewIqamaApplicationsItem(params) {
  return request({
    url: `/api/v1/renewIqamaApplications/${params.key}`,
    method: "get",
    params,
  });
}
//付费
export function payRenewIqamaApplication(data) {
  return request({
    url: `/api/v1/renewIqamaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeRenewIqamaApplication(data) {
  return request({
    url: `/api/v1/renewIqamaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteRenewIqamaApplications(params) {
  return request({
    url: `/api/v1/renewIqamaApplications/delete`,
    method: "delete",
    params,
  });
}

//导出
export function exportRenewIqamaApplication(params) {
  return request({
    url: `/api/v1/renewIqamaApplication/export`,
    method: "get",
    params,
  });
}

//导入
export function importRenewIqamaApplication(data) {
  return request({
    url: `/api/v1/renewIqamaApplication/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateRenewIqamaApplication(params) {
  return request({
    url: `/api/v1/renewIqamaApplication/import/template`,
    method: "",
    params,
  });
}

// 48、更改职位

// 48-1 列表
export function getChangeIqamaProfessionApplications2(params) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addChangeIqamaProfessionApplication(data) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editChangeIqamaProfessionApplication(data) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getChangeIqamaProfessionApplicationsItem(params) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payChangeIqamaProfessionApplication(data) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeChangeIqamaProfessionApplication(data) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteChangeIqamaProfessionApplication(params) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/delete`,
    method: "delete",
    params,
  });
}

//导出
export function exportChangeIqamaProfessionApplication(params) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/export`,
    method: "get",
    params,
  });
}

//导入
export function importChangeIqamaProfessionApplication(data) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateChangeIqamaProfessionApplication(params) {
  return request({
    url: `/api/v1/changeIqamaProfessionApplication/import/template`,
    method: "",
    params,
  });
}

// 49、单次往返签证办理

// 49-1 列表
export function getSingleExitReentryVisaApplications2(params) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addSingleExitReentryVisaApplications(data) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editSingleExitReentryVisaApplications(data) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getSingleExitReentryVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function paySingleExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeSingleExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteSingleExitReentryVisaApplication(params) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 50、多次往返签证办理

// 50-1 列表
export function getMultipleExitReentryVisaApplications2(params) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addMultipleExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editMultipleExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getMultipleExitReentryVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payMultipleExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeMultipleExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteMultipleExitReentryVisaApplication(params) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 51、往返签证延期

// 51-1 列表
export function getextendExitReentryVisaApplications2(params) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addExtendExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editExtendExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getExtendExitReentryVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payExtendExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeExtendExitReentryVisaApplication(data) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteExtendExitReentryVisaApplication(params) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 52、商务访签办理

// 52-1 列表
export function getissueBusinessVisitVisaApplications2(params) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addissueBusinessVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function ediissueBusinessVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getissueBusinessVisitVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payIssueBusinessVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeIssueBusinessVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteIssueBusinessVisitVisaApplication(params) {
  return request({
    url: `/api/v1/issueBusinessVisitVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 53、 商务访签延期

// 52-1 列表
export function getbusinessVisitVisaExtensionApplications2(params) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addbusinessVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editbusinessVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getbusinessVisitVisaExtensionApplicationsItem(params) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payBusinessVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeBusinessVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteBusinessVisitVisaExtensionApplication(params) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplication/delete`,
    method: "delete",
    params,
  });
}

// 53、 工作访签办理

// 53-1 列表
export function getIssueWorkingVisitVisaApplications2(params) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addIssueWorkingVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editIssueWorkingVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getissueWorkingVisitVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payIssueWorkingVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeIssueWorkingVisitVisaApplication(data) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteIssueWorkingVisitVisaApplication(params) {
  return request({
    url: `/api/v1/issueWorkingVisitVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 54、 工作访签延期

// 54-1 列表
export function getWorkingVisitVisaExtensionApplications2(params) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addWorkingVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editWorkingVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getWorkingVisitVisaExtensionApplicationsItem(params) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payWorkingVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeWorkingVisitVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteWorkingVisitVisaExtensionApplication(params) {
  return request({
    url: `/api/v1/workingVisitVisaExtensionApplication/delete`,
    method: "delete",
    params,
  });
}

// 55、 临时工作签证办理

// 55-1 列表
export function getIssueTemporaryWorkingVisaApplications2(params) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addIssueTemporaryWorkingVisaApplication(data) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editIssueTemporaryWorkingVisaApplication(data) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getIssueTemporaryWorkingVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payIssueTemporaryWorkingVisaApplication(data) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeIssueTemporaryWorkingVisaApplication(data) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteIssueTemporaryWorkingVisaApplication(params) {
  return request({
    url: `/api/v1/issueTemporaryWorkingVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 56、 临时工作签证延期

// 56-1 列表
export function getTemporaryWrokingVisaExtensionApplications2(params) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addTemporaryWrokingVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editTemporaryWrokingVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getTemporaryWrokingVisaExtensionApplicationsItem(params) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payTemporaryWrokingVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeTemporaryWrokingVisaExtensionApplication(data) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteTemporaryWrokingVisaExtensionApplication(params) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplication/delete`,
    method: "delete",
    params,
  });
}

// 57、 暂住证注销

// 57-1 列表
export function getCancelIqamaApplications2(params) {
  return request({
    url: `/api/v1/cancelIqamaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addCancelIqamaApplication(data) {
  return request({
    url: `/api/v1/cancelIqamaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editCancelIqamaApplication(data) {
  return request({
    url: `/api/v1/cancelIqamaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getCancelIqamaApplicationsItem(params) {
  return request({
    url: `/api/v1/cancelIqamaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payCancelIqamaApplication(data) {
  return request({
    url: `/api/v1/cancelIqamaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeCancelIqamaApplication(data) {
  return request({
    url: `/api/v1/cancelIqamaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteCancelIqamaApplication(params) {
  return request({
    url: `/api/v1/cancelIqamaApplication/delete`,
    method: "delete",
    params,
  });
}

//58、 离境签证办理

// 58-1 列表
export function getIssueExitVisaApplications2(params) {
  return request({
    url: `/api/v1/issueExitVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addIssueExitVisaApplication(data) {
  return request({
    url: `/api/v1/issueExitVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editIssueExitVisaApplication(data) {
  return request({
    url: `/api/v1/issueExitVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getIssueExitVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/issueExitVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payIssueExitVisaApplication(data) {
  return request({
    url: `/api/v1/issueExitVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeIssueExitVisaApplication(data) {
  return request({
    url: `/api/v1/issueExitVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteIssueExitVisaApplication(params) {
  return request({
    url: `/api/v1/issueExitVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 59、 离境签证注销

// 59-1 列表
export function getCancelExitVisaApplications2(params) {
  return request({
    url: `/api/v1/cancelExitVisaApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addCancelExitVisaApplication(data) {
  return request({
    url: `/api/v1/cancelExitVisaApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editCancelExitVisaApplication(data) {
  return request({
    url: `/api/v1/cancelExitVisaApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getCncelExitVisaApplicationsItem(params) {
  return request({
    url: `/api/v1/cancelExitVisaApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payCancelExitVisaApplication(data) {
  return request({
    url: `/api/v1/cancelExitVisaApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeCancelExitVisaApplication(data) {
  return request({
    url: `/api/v1/cancelExitVisaApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteCancelExitVisaApplication(params) {
  return request({
    url: `/api/v1/cancelExitVisaApplication/delete`,
    method: "delete",
    params,
  });
}

// 60、 护照信息更新

// 60-1 列表
export function getUpdatePassportApplications2(params) {
  return request({
    url: `/api/v1/updatePassportApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addUpdatePassportApplication(data) {
  return request({
    url: `/api/v1/updatePassportApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editUpdatePassportApplication(data) {
  return request({
    url: `/api/v1/updatePassportApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getUpdatePassportApplicationsItem(params) {
  return request({
    url: `/api/v1/updatePassportApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payUpdatePassportApplication(data) {
  return request({
    url: `/api/v1/updatePassportApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeUpdatePassportApplication(data) {
  return request({
    url: `/api/v1/updatePassportApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteuUatePassportApplication(params) {
  return request({
    url: `/api/v1/updatePassportApplication/delete`,
    method: "delete",
    params,
  });
}

// 61、 付费标准

// 列表
export function getForeignAffairsCosts(params) {
  return request({
    url: `/api/v1/foreignAffairsCosts`,
    method: "get",
    params,
  });
}

//新增
export function addForeignAffairsCost(data) {
  return request({
    url: `/api/v1/foreignAffairsCost/add`,
    method: "post",
    data,
  });
}

//编辑
export function editForeignAffairsCost(data) {
  return request({
    url: `/api/v1/foreignAffairsCost/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteForeignAffairsCost(data) {
  return request({
    url: `/api/v1/foreignAffairsCost/delete`,
    method: "delete",
    data,
  });
}

//导出
export function exportForeignAffairsCost(params) {
  return request({
    url: `/api/v1/foreignAffairsCost/export`,
    method: "get",
    params,
  });
}

//62、付费明细

//列表
export function getForeignAffairsPayments(params) {
  return request({
    url: `/api/v1/foreignAffairsPayments`,
    method: "get",
    params,
  });
}

//导出

export function exportForeignAffairsPayments(params) {
  return request({
    url: `/api/v1/foreignAffairsPayment/export`,
    method: "get",
    params,
  });
}

// 更新
export function updateFeeForeignAffairsPayment(data) {
  return request({
    url: `/api/v1/foreignAffairsPayment/updateFee`,
    method: "put",
    data,
  });
}

//确认金额
export function confirmFeeForeignAffairsPayment(data) {
  return request({
    url: `/api/v1/foreignAffairsPayment/confirm`,
    method: "post",
    data,
  });
}

//费用汇总
export function summaryForeignAffairsPayment(data) {
  return request({
    url: `/api/v1/foreignAffairsPayment/summary`,
    method: "post",
    data,
  });
}

//63、付费明细汇总

export function getForeignAffairsPaymentSummaryApplicationDetails(params) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetails`,
    method: "get",
    params,
  });
}

//导出
export function exportForeignAffairsPaymentSummaryApplicationDetail(params) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/export`,
    method: "get",
    params,
  });
}

//费用更新

export function updateForeignAffairsPaymentSummaryApplicationDetail(data) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/put`,
    method: "post",
    data,
  });
}

//删除
export function deleteForeignAffairsPaymentSummaryApplicationDetail(data) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/delete`,
    method: "delete",
    data,
  });
}

//获取汇总表明细
export function getForeignAffairsPaymentSummaryApplicationDetailPayments(
  params,
) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/payments`,
    method: "get",
    params,
  });
}

//明细导出
export function exportForeignAffairsPaymentSummaryApplicationDetailPayment(
  params,
) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/payment/export`,
    method: "get",
    params,
  });
}
//获取汇总表明细申请单
export function getForeignAffairsApplication(params) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/foreignAffairsApplication`,
    method: "get",
    params,
  });
}
// 获取汇总表成本分割表
export function getForeignAffairsPaymentSummaryApplicationDetailCostDivides(
  params,
) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/costDivides`,
    method: "get",
    params,
  });
}
//导出
export function exportForeignAffairsPaymentSummaryApplicationDetailCostDivide(
  params,
) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplicationDetail/costDivide/export`,
    method: "get",
    params,
  });
}

//64、付费明细汇总审批

// 64-1 列表
export function getForeignAffairsPaymentSummaryApplications(params) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplications`,
    method: "get",
    params,
  });
}

//新增
export function addForeignAffairsPaymentSummaryApplication(data) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editForeignAffairsPaymentSummaryApplication(data) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getForeignAffairsPaymentSummaryApplicationItem(params) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplication/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deletForeignAffairsPaymentSummaryApplication(data) {
  return request({
    url: `/api/v1/foreignAffairsPaymentSummaryApplication/delete`,
    method: "delete",
    data,
  });
}

//65.付费台账

// 65-1 列表
export function getForeignAffairsAccounting(params) {
  return request({
    url: `/api/v1/foreignAffairsAccountings`,
    method: "get",
    params,
  });
}

//导出
export function exportForeignAffairsAccounting(params) {
  return request({
    url: `/api/v1/foreignAffairsAccounting/export`,
    method: "get",
    params,
  });
}

// 66、 特殊付费

// 66-1 列表
export function getMuqeemSystemApplications2(params) {
  return request({
    url: `/api/v1/otherPaymentApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addMuqeemSystemApplication(data) {
  return request({
    url: `/api/v1/otherPaymentApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editMuqeemSystemApplication(data) {
  return request({
    url: `/api/v1/otherPaymentApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getMuqeemSystemApplicationsItem(params) {
  return request({
    url: `/api/v1/otherPaymentApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payMuqeemSystemApplication(data) {
  return request({
    url: `/api/v1/otherPaymentApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeMuqeemSystemApplication(data) {
  return request({
    url: `/api/v1/otherPaymentApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteMuqeemSystemApplication(params) {
  return request({
    url: `/api/v1/otherPaymentApplication/delete`,
    method: "delete",
    params,
  });
}

// 67、签证指标管理

// 67-1 列表
export function getWorkVisaQuotas(params) {
  return request({
    url: `/api/v1/workVisaQuotas`,
    method: "get",
    params,
  });
}

//导出
export function exportWorkVisaQuotas(params) {
  return request({
    url: `/api/v1/workVisaQuotas/export`,
    method: "get",
    params,
  });
}

//新增
export function addWorkVisaQuotas(data) {
  return request({
    url: `/api/v1/workVisaQuota/add`,
    method: "post",
    data,
  });
}

//修改
export function editWorkVisaQuotas(data) {
  return request({
    url: `/api/v1/workVisaQuota/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteWorkVisaQuotas(data) {
  return request({
    url: `/api/v1/workVisaQuota/delete`,
    method: "delete",
    data,
  });
}

// 68、签证指标使用记录

// 68-1 列表
export function getWorkVisaQuotaUsageRecords(params) {
  return request({
    url: `/api/v1/workVisaQuotaUsageRecords`,
    method: "get",
    params,
  });
}

//导出
export function exportWorkVisaQuotaUsageRecords(params) {
  return request({
    url: `/api/v1/workVisaQuotaUsageRecords/export`,
    method: "get",
    params,
  });
}

//查询
export function warningWorkVisaQuotaUsageRecords(params) {
  return request({
    url: `/api/v1/workVisaQuotaUsageRecords/warning`,
    method: "get",
    params,
  });
}

//添加
export function addWorkVisaQuotaUsageRecords(data) {
  return request({
    url: `/api/v1/workVisaQuotaUsageRecords/add`,
    method: "post",
    data,
  });
}

// 69、Sponsor

//获取全部
export function getSponsorAll(params) {
  return request({
    url: `/api/v1/sponsor/all`,
    method: "get",
    params,
  });
}

//列表
export function getSponsors(params) {
  return request({
    url: `/api/v1/sponsors`,
    method: "get",
    params,
  });
}

//添加
export function addSponsor(data) {
  return request({
    url: `/api/v1/sponsor/add`,
    method: "post",
    data,
  });
}
//修改
export function updateSponsor(data) {
  return request({
    url: `/api/v1/sponsor/update`,
    method: "post",
    data,
  });
}
//删除
export function deleteSponsor(data) {
  return request({
    url: `/api/v1/sponsor/delete`,
    method: "delete",
    data,
  });
}

//70、项目人员调转

//列表
export function getEmployeeInternalTransferOrderApplications2(params) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeInternalTransferOrderApplication(data) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeInternalTransferOrderApplication(data) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getEmployeeInternalTransferOrderApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderApplications/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeeInternalTransferOrderApplications(data) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderApplication/delete `,
    method: "delete",
    data,
  });
}

//71、 项目人员调转台账

//列表
export function getEmployeeInternalTransferOrderAccountings(params) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderAccountings`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeeInternalTransferOrderAccounting(params) {
  return request({
    url: `/api/v1/employeeInternalTransferOrderAccounting/export`,
    method: "get",
    params,
  });
}

// 72、安全帽款式管理

//获取全部
export function getPPEDicAll(params) {
  return request({
    url: `/api/v1/PPEDic/all`,
    method: "get",
    params,
  });
}

//列表
export function getPPEDics(params) {
  return request({
    url: `/api/v1/PPEDics`,
    method: "get",
    params,
  });
}

//添加
export function addPPEDic(data) {
  return request({
    url: `/api/v1/PPEDic/add`,
    method: "post",
    data,
  });
}
//修改
export function updatePPEDic(data) {
  return request({
    url: `/api/v1/PPEDic/update`,
    method: "post",
    data,
  });
}
//删除
export function deletePPEDic(data) {
  return request({
    url: `/api/v1/PPEDic/delete`,
    method: "delete",
    data,
  });
}

//73、劳保防护用品申请

//列表
export function getPPERequestApplications2(params) {
  return request({
    url: `/api/v1/PPERequestApplications2`,
    method: "get",
    params,
  });
}

//详情
export function getPPERequestApplicationsItem(params) {
  return request({
    url: `/api/v1/PPERequestApplications/${params.key}`,
    method: "get",
    params,
  });
}
//添加
export function addPPERequestApplications(data) {
  return request({
    url: `/api/v1/PPERequestApplication/add`,
    method: "post",
    data,
  });
}
//修改
export function editPPERequestApplications(data) {
  return request({
    url: `/api/v1/PPERequestApplication/edit`,
    method: "post",
    data,
  });
}

//删除
export function deletePPERequestApplications(data) {
  return request({
    url: `/api/v1/PPERequestApplication/delete`,
    method: "delete",
    data,
  });
}

//下载模板
export function importPPERequestApplicationsTemplate(params) {
  return request({
    url: `/api/v1/PPERequestApplication/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importPPERequestApplication(data) {
  return request({
    url: `/api/v1/PPERequestApplication/import`,
    method: "post",
    data,
  });
}

// 74、 往返签证注销

// 74-1 列表
export function getCancelExitReentryApplications2(params) {
  return request({
    url: `/api/v1/cancelExitReentryApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addCancelExitReentryApplication(data) {
  return request({
    url: `/api/v1/cancelExitReentryApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editCancelExitReentryApplication(data) {
  return request({
    url: `/api/v1/cancelExitReentryApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getCancelExitReentryApplicationsItem(params) {
  return request({
    url: `/api/v1/cancelExitReentryApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payCancelExitReentryApplication(data) {
  return request({
    url: `/api/v1/cancelExitReentryApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeCancelExitReentryApplication(data) {
  return request({
    url: `/api/v1/cancelExitReentryApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteuCancelExitReentryApplication(params) {
  return request({
    url: `/api/v1/cancelExitReentryApplication/delete`,
    method: "delete",
    params,
  });
}

// 75、劳保发放数据库

// 75-1 列表
export function getPPERequestAccountings(params) {
  return request({
    url: `/api/v1/PPERequestAccountings`,
    method: "get",
    params,
  });
}

//导出
export function exportPPERequestAccountings(params) {
  return request({
    url: `/api/v1/PPERequestAccounting/export`,
    method: "get",
    params,
  });
}

// 76、员工劳保档案
export function getUserPPEDocs(params) {
  return request({
    url: `/api/v1/userPPEDocs`,
    method: "get",
    params,
  });
}

export function getUserPPEDocsCode(params) {
  return request({
    url: `/api/v1/userPPEDocs/${params.userCode}`,
    method: "get",
    params,
  });
}
export function updatePeriod(data) {
  return request({
    url: `/api/v1/userPPEDoc/updatePeriod`,
    method: "post",
    data,
  });
}

export function getPPERequests(params) {
  return request({
    url: `/api/v1/userPPEDoc/PPERequests`,
    method: "get",
    params,
  });
}

export function templatePPERequests(params) {
  return request({
    url: `/api/v1/userPPEDoc/import/template`,
    method: "get",
    params,
  });
}

export function importUserPPEDoc(data) {
  return request({
    url: `/api/v1/userPPEDoc/import`,
    method: "post",
    data,
  });
}

export function exportUserPPEDoc(params) {
  return request({
    url: `/api/v1/userPPEDoc/export`,
    method: "get",
    params,
  });
}

//77、员工端员工证明

// 77-1 列表
export function getEmployeeCertificateApplications(params) {
  return request({
    url: `/api/v1/employee/employeeCertificateApplications`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeCertificateApplication(data) {
  return request({
    url: `/api/v1/employee/employeeCertificateApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeCertificateApplication(data) {
  return request({
    url: `/api/v1/employee/employeeCertificateApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getEmployeeCertificateApplicationsItem(params) {
  return request({
    url: `/api/v1/employee/employeeCertificateApplications/${params.key}`,
    method: "get",
    params,
  });
}

//删除

export function deleteEmployeeCertificateApplication(params) {
  return request({
    url: `/api/v1/employee/employeeCertificateApplication/delete`,
    method: "delete",
    params,
  });
}

//78、管理端员工证明

//列表
export function getEmployeeCertificateApplications2(params) {
  return request({
    url: `/api/v1/employeeCertificateApplications`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeCertificateApplication2(data) {
  return request({
    url: `/api/v1/employeeCertificateApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeCertificateApplication2(data) {
  return request({
    url: `/api/v1/employeeCertificateApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getEmployeeCertificateApplicationsItem2(params) {
  return request({
    url: `/api/v1/employeeCertificateApplications/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeeCertificateApplication2(data) {
  return request({
    url: `/api/v1/employeeCertificateApplication/delete`,
    method: "delete",
    data,
  });
}

//修改岗位/职业类别是否打印
export function putEmployeeCertificateApplicationBasicInfo(data) {
  return request({
    url: `/api/v1/employeeCertificateApplication/basicInfo/put`,
    method: "post",
    data,
  });
}

//修改工资明细是否打印
export function putEmployeeCertificateApplicationSalaryDetail(data) {
  return request({
    url: `/api/v1/employeeCertificateApplication/salaryDetail/put`,
    method: "post",
    data,
  });
}

// 79、工资条相关

//工资列表
export function getSalaries(params) {
  return request({
    url: `/api/v1/employee/salaries`,
    method: "get",
    params,
  });
}

//工资详情
export function getSalariesDetail(params) {
  return request({
    url: `/api/v1/employee/salaries/detail`,
    method: "get",
    params,
  });
}

// 奖金列表
export function getEmployeebonus(params) {
  return request({
    url: `/api/v1/employee/bonus`,
    method: "get",
    params,
  });
}

//国内发放
export function getDomesticPayments(params) {
  return request({
    url: `/api/v1/employee/domesticPayments`,
    method: "get",
    params,
  });
}

//80、个人社保两金及个税清缴

//列表
export function getEmployeeSettlementInfos(params) {
  return request({
    url: `/api/v1/employeeSettlementInfos`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeSettlementInfo(data) {
  return request({
    url: `/api/v1/employeeSettlementInfo/add`,
    method: "post",
    data,
  });
}

//修改
export function updateEmployeeSettlementInfo(data) {
  return request({
    url: `/api/v1/employeeSettlementInfo/update`,
    method: "post",
    data,
  });
}

//详情

export function getEmployeeSettlementInfosItem(params) {
  return request({
    url: `/api/v1/employeeSettlementInfos/${params.id}`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeeSettlementInfosItem(data) {
  return request({
    url: `/api/v1/employeeSettlementInfo/delete`,
    method: "delete",
    data,
  });
}

//获取最近发布的
export function latestEmployeeSettlementInfos(params) {
  return request({
    url: `/api/v1/employeeSettlementInfos/latest`,
    method: "get",
    params,
  });
}

//81、个税清缴

//列表
export function getEmployeeSettlements(params) {
  return request({
    url: `/api/v1/employeeSettlements`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeSettlements(data) {
  return request({
    url: `/api/v1/employeeSettlement/add`,
    method: "post",
    data,
  });
}

//修改
export function editEmployeeSettlements(data) {
  return request({
    url: `/api/v1/employeeSettlement/edit`,
    method: "post",
    data,
  });
}

//详情
export function getEmployeeSettlementsItem(params) {
  return request({
    url: `/api/v1/employeeSettlements/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeeSettlements(data) {
  return request({
    url: `/api/v1/employeeSettlement/delete`,
    method: "delete",
    data,
  });
}

//导入
export function importEmployeeSettlements(data) {
  return request({
    url: `/api/v1/employeeSettlement/import`,
    method: "post",
    data,
  });
}

//下载

export function getEmployeeSettlementsTemplate(params) {
  return request({
    url: `/api/v1/employeeSettlement/import/template`,
    method: "get",
    params,
  });
}

// 发布
export function publishEmployeeSettlement(data) {
  return request({
    url: `/api/v1/employeeSettlement/publish`,
    method: "post",
    data,
  });
}

//82、个税清缴员工端

//列表
export function getEmployeeSettlements2(params) {
  return request({
    url: `/api/v1/employee/settlements`,
    method: "get",
    params,
  });
}

//详情
export function getEmployeeSettlementsItem2(params) {
  return request({
    url: `/api/v1/employee/settlements/${params.key}`,
    method: "get",
    params,
  });
}

//83、员工管理

//列表
export function getEmployeeMedicalInsurances(params) {
  return request({
    url: `/api/v1/employeeMedicalInsurances`,
    method: "get",
    params,
  });
}

//详情
export function getEmployeeMedicalInsurancesItem(params) {
  return request({
    url: `/api/v1/employeeMedicalInsurances/${params.id}`,
    method: "get",
    params,
  });
}

//模板
export function getEmployeeMedicalInsurancesTemplate(params) {
  return request({
    url: `/api/v1/employeeMedicalInsurance/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeMedicalInsurances(data) {
  return request({
    url: `/api/v1/employeeMedicalInsurance/import`,
    method: "post",
    data,
  });
}

//导出
export function exportEmployeeMedicalInsurances(params) {
  return request({
    url: `/api/v1/employeeMedicalInsurance/export`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeeMedicalInsurances(data) {
  return request({
    url: `/api/v1/employeeMedicalInsurance/delete`,
    method: "delete",
    data,
  });
}

//统计
export function getsEmployeeMedicalInsurancesStats(params) {
  return request({
    url: `/api/v1/employeeMedicalInsurance/stats`,
    method: "get",
    params,
  });
}

//修改医保状态
export function processEmployeeMedicalInsurances(data) {
  return request({
    url: `/api/v1/employeeMedicalInsurance/process`,
    method: "post",
    data,
  });
}

//84、用工形式管理

//列表
export function getEmploymentForms(params) {
  return request({
    url: `/api/v1/employmentForms`,
    method: "get",
    params,
  });
}

//新增
export function addEmploymentForm(data) {
  return request({
    url: `/api/v1/employmentForm/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateEmploymentForm(data) {
  return request({
    url: `/api/v1/employmentForm/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmploymentForm(data) {
  return request({
    url: `/api/v1/employmentForm/delete`,
    method: "delete",
    data,
  });
}

//详情
export function getEmploymentFormsItem(params) {
  return request({
    url: `/api/v1/employmentForms/${params.id}`,
    method: "get",
    params,
  });
}

//85、员工劳动防护用品年度计划表

//列表
export function getAuxiliaryMaterialApplications2(params) {
  return request({
    url: `/api/v1/auxiliaryMaterialApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addAxiliaryMaterialApplication(data) {
  return request({
    url: `/api/v1/auxiliaryMaterialApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editAxiliaryMaterialApplication(data) {
  return request({
    url: `/api/v1/auxiliaryMaterialApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getAuxiliaryMaterialApplicationsItem(params) {
  return request({
    url: `/api/v1/auxiliaryMaterialApplications/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deleteAuxiliaryMaterialApplications(data) {
  return request({
    url: `/api/v1/auxiliaryMaterialApplication/delete`,
    method: "delete",
    data,
  });
}

//86、岗位性质

//获取全部

export function getJobNaturesAll(params) {
  return request({
    url: `/api/v1/jobNature/all`,
    method: "get",
    params,
  });
}

//列表
export function getJobNatures(params) {
  return request({
    url: `/api/v1/jobNatures`,
    method: "get",
    params,
  });
}

//新增
export function addJobNature(data) {
  return request({
    url: `/api/v1/jobNature/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateJobNature(data) {
  return request({
    url: `/api/v1/jobNature/update`,
    method: "post",
    data,
  });
}

//详情
export function getJobNatureItem(params) {
  return request({
    url: `/api/v1/jobNatures/${params.id}`,
    method: "get",
    params,
  });
}

//删除
export function deleteJobNature(data) {
  return request({
    url: `/api/v1/jobNature/delete`,
    method: "delete",
    data,
  });
}

//87、境外项目质量

//列表
export function getTrainingCourseApplications2(params) {
  return request({
    url: `/api/v1/trainingCourseApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addTrainingCourseApplication(data) {
  return request({
    url: `/api/v1/trainingCourseApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editTrainingCourseApplication(data) {
  return request({
    url: `/api/v1/trainingCourseApplication/edit`,
    method: "post",
    data,
  });
}

//导入模板
export function importTrainingCourseApplicationTemplate(params) {
  return request({
    url: `/api/v1/trainingCourseApplication/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importTrainingCourseApplication(data) {
  return request({
    url: `/api/v1/trainingCourseApplication/import`,
    method: "post",
    data,
  });
}

//导出
export function exportTrainingCourseApplication(params) {
  return request({
    url: `/api/v1/trainingCourseApplication/export`,
    method: "get",
    params,
  });
}

//详情
export function getTrainingCourseApplicationItem(params) {
  return request({
    url: `/api/v1/trainingCourseApplications/${params.key}`,
    method: "get",
    params,
  });
}

//删除
export function deleteTrainingCourseApplication(data) {
  return request({
    url: `/api/v1/trainingCourseApplication/delete`,
    method: "delete",
    data,
  });
}

//88、境外项目质量台账

//列表
export function getTrainingCourseAccountings(params) {
  return request({
    url: `/api/v1/trainingCourseAccountings`,
    method: "get",
    params,
  });
}

//添加
export function addTrainingCourseAccountings(data) {
  return request({
    url: `/api/v1/trainingCourseAccountings/add`,
    method: "post",
    data,
  });
}

//修改
export function editTrainingCourseAccountings(data) {
  return request({
    url: `/api/v1/trainingCourseAccountings/edit`,
    method: "post",
    data,
  });
}

//修改费用
export function updateFeeTrainingCourseAccounting(data) {
  return request({
    url: `/api/v1/trainingCourseAccounting/updateFee`,
    method: "put",
    data,
  });
}

//导入模板
export function importTrainingCourseAccountingTemplate(params) {
  return request({
    url: `/api/v1/trainingCourseAccounting/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importTrainingCourseAccounting(data) {
  return request({
    url: `/api/v1/trainingCourseAccounting/import`,
    method: "post",
    data,
  });
}

//导出
export function exportTrainingCourseAccounting(params) {
  return request({
    url: `/api/v1/trainingCourseAccounting/export`,
    method: "get",
    params,
  });
}

//删除
export function deleteTrainingCourseAccounting(data) {
  return request({
    url: `/api/v1/trainingCourseAccounting/delete`,
    method: "delete",
    data,
  });
}

//89、快捷方式

//列表
export function getMyModules(params) {
  return request({
    url: `/api/v1/myModules`,
    method: "get",
    params,
  });
}

//增加
export function addMyModule(data) {
  return request({
    url: `/api/v1/myModule/add`,
    method: "post",
    data,
  });
}

//修改
export function updateMyModule(data) {
  return request({
    url: `/api/v1/myModule/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteMyModule(data) {
  return request({
    url: `/api/v1/myModule/delete`,
    method: "delete",
    data,
  });
}

//获取所有
export function getMyModuleAll(params) {
  return request({
    url: `/api/v1/myModule/modules`,
    method: "get",
    params,
  });
}

//90、员工薪资标准调整

// 列表
export function getSalaryAdjustmentApplications2(params) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplications2`,
    method: "get",
    params,
  });
}

//添加
export function addSalaryAdjustmentApplication(data) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplication/add`,
    method: "post",
    data,
  });
}

//修改
export function editSalaryAdjustmentApplication(data) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplication/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteSalaryAdjustmentApplication(data) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplication/delete`,
    method: "delete",
    data,
  });
}

//详情
export function getSalaryAdjustmentApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplications/${params.key}`,
    method: "get",
    params,
  });
}

//导入模板
export function getSalaryAdjustmentApplicationsTemplate(params) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplication/import/template`,
    method: "get",
    params,
  });
}

// 导入
export function importSalaryAdjustmentApplications(data) {
  return request({
    url: `/api/v1/employeeSalaryAdjustmentApplication/import`,
    method: "post",
    data,
  });
}

//91、境外保险购买申请

// 列表
export function getEmployeePersonalAccidentInsuranceApplications2(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplications2`,
    method: "get",
    params,
  });
}

//添加
export function addEmployeePersonalAccidentInsuranceApplication(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplication/add`,
    method: "post",
    data,
  });
}

//修改
export function editEmployeePersonalAccidentInsuranceApplication(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplication/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeePersonalAccidentInsuranceApplication(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplication/delete`,
    method: "delete",
    data,
  });
}

//详情
export function getEmployeePersonalAccidentInsuranceApplicationsItem(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplications/${params.key}`,
    method: "get",
    params,
  });
}

//导入模板
export function getEmployeePersonalAccidentInsuranceApplicationTemplate(
  params,
) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplication/import/template`,
    method: "get",
    params,
  });
}

// 导入
export function importEmployeePersonalAccidentInsuranceApplication(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceApplication/import`,
    method: "post",
    data,
  });
}

// 92、境外公共安全培训管理

// 列表
export function getPublicSafetyTrainings(params) {
  return request({
    url: `/api/v1/publicSafetyTrainings`,
    method: "get",
    params,
  });
}

//下载模板
export function getPublicSafetyTrainingsTemplate(params) {
  return request({
    url: `/api/v1/publicSafetyTraining/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importPublicSafetyTrainings(data) {
  return request({
    url: `/api/v1/publicSafetyTraining/import`,
    method: "post",
    data,
  });
}

//导出
export function exportPublicSafetyTrainings(params) {
  return request({
    url: `/api/v1/publicSafetyTraining/export`,
    method: "get",
    params,
  });
}

//删除
export function deletePublicSafetyTrainings(data) {
  return request({
    url: `/api/v1/publicSafetyTraining/delete`,
    method: "delete",
    data,
  });
}

//处理
export function processPublicSafetyTrainings(data) {
  return request({
    url: `/api/v1/publicSafetyTraining/process`,
    method: "post",
    data,
  });
}

//详情
export function getPublicSafetyTrainingsItem(params) {
  return request({
    url: `/api/v1/publicSafetyTrainings/${params.id}`,
    method: "get",
    params,
  });
}

// 93、人身意外保险管理

// 列表
export function getEmployeePersonalAccidentInsurances(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurances`,
    method: "get",
    params,
  });
}

//下载模板
export function getEmployeePersonalAccidentInsuranceTemplate(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurance/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeePersonalAccidentInsurance(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurance/import`,
    method: "post",
    data,
  });
}

//导出
export function exportEmployeePersonalAccidentInsurance(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurance/export`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeePersonalAccidentInsurance(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurance/delete`,
    method: "delete",
    data,
  });
}

//处理
export function processEmployeePersonalAccidentInsurance(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurance/process`,
    method: "post",
    data,
  });
}

//详情
export function getEmployeePersonalAccidentInsurancesItem(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsurances/${params.id}`,
    method: "get",
    params,
  });
}

// 94、签证指标退还

// 列表
export function getworkVisaQuotaReturns2(params) {
  return request({
    url: `/api/v1/workVisaQuotaReturns2`,
    method: "get",
    params,
  });
}

//详情
export function getworkVisaQuotaReturnsItem(params) {
  return request({
    url: `/api/v1/workVisaQuotaReturns/${params.key}`,
    method: "get",
    params,
  });
}

//新增
export function addworkVisaQuotaReturns(data) {
  return request({
    url: `/api/v1/workVisaQuotaReturn/add`,
    method: "post",
    data,
  });
}

//编辑
export function editworkVisaQuotaReturns(data) {
  return request({
    url: `/api/v1/workVisaQuotaReturn/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteworkVisaQuotaReturns(params) {
  return request({
    url: `/api/v1/workVisaQuotaReturn/delete`,
    method: "delete",
    params,
  });
}

// 95、员工工作经历

// 列表
export function getEmployeeWorkExperiences(params) {
  return request({
    url: `/api/v1/employeeWorkExperiences`,
    method: "get",
    params,
  });
}

// 导出
export function exportEmployeeWorkExperiences(params) {
  return request({
    url: `/api/v1/employeeWorkExperience/export`,
    method: "get",
    params,
  });
}

//96、员工合同台账

// 列表
export function getEmploymentContractAccountings(params) {
  return request({
    url: `/api/v1/employmentContractAccountings`,
    method: "get",
    params,
  });
}

// 导出
export function exportEmploymentContractAccounting(params) {
  return request({
    url: `/api/v1/employmentContractAccounting/export`,
    method: "get",
    params,
  });
}

//97、人员健康档案管理

// 列表
export function getEmployeeHealthInfos2(params) {
  return request({
    url: `/api/v1/employeeHealthInfos2`,
    method: "get",
    params,
  });
}

//新增
export function saveEmployeeHealthInfo(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/save`,
    method: "post",
    data,
  });
}

//导入
export function importEmployeeHealthInfoHealthCheck(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthCheck/import`,
    method: "post",
    data,
  });
}

//导入模板
export function TemplateEmployeeHealthInfoHealthCheck(params) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthCheck/import/template`,
    method: "get",
    params,
  });
}

//删除
export function deleteEmployeeHealthInfo(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/delete`,
    method: "delete",
    data,
  });
}

//详情
export function getEmployeeHealthInfoItem(params) {
  return request({
    url: `/api/v1/employeeHealthInfos/${params.userCode}`,
    method: "get",
    params,
  });
}

//
export function addEmployeeHealthInfoHealthCheck(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthCheck/add`,
    method: "post",
    data,
  });
}

export function addEmployeeHealthInfoHealthReport(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthReport/add`,
    method: "post",
    data,
  });
}

export function getEmployeeHealthInfoHealthChecks(params) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthChecks`,
    method: "get",
    params,
  });
}

export function deleteEmployeeHealthInfoHealthCheck(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthCheck/delete`,
    method: "delete",
    data,
  });
}

// 附件列表
export function getEmployeeHealthInfoHealthReport(params) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthReports`,
    method: "get",
    params,
  });
}

//
export function deleteEmployeeHealthInfoHealthReport(data) {
  return request({
    url: `/api/v1/employeeHealthInfo/healthReport/delete`,
    method: "delete",
    data,
  });
}

//98、健康风险评估记录管理

// 列表
export function getEmployeeHealthRiskAssessments2(params) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessments2`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeHealthRiskAssessment(data) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessment/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateImportEmployeeHealthRiskAssessment(params) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessment/import/template`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeeHealthRiskAssessment(params) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessment/export`,
    method: "get",
    params,
  });
}

export function deleteEmployeeHealthRiskAssessment(data) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessment/delete`,
    method: "delete",
    data,
  });
}

//新增
export function addEmployeeHealthRiskAssessment(data) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessment/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeHealthRiskAssessment(data) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessment/edit`,
    method: "post",
    data,
  });
}

//详情
export function getEmployeeHealthRiskAssessmentItem(params) {
  return request({
    url: `/api/v1/employeeHealthRiskAssessments/${params.key}`,
    method: "get",
    params,
  });
}

//99、季度体检记录管理

// 列表
export function getQuarterlyPhysicalExaminations2(params) {
  return request({
    url: `/api/v1/quarterlyPhysicalExaminations2`,
    method: "get",
    params,
  });
}

//导入
export function importQuarterlyPhysicalExamination(data) {
  return request({
    url: `/api/v1/quarterlyPhysicalExamination/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateQuarterlyPhysicalExamination(params) {
  return request({
    url: `/api/v1/quarterlyPhysicalExamination/import/template`,
    method: "get",
    params,
  });
}

//导出
export function exportQuarterlyPhysicalExamination(params) {
  return request({
    url: `/api/v1/quarterlyPhysicalExamination/export`,
    method: "get",
    params,
  });
}

//新增
export function addQuarterlyPhysicalExamination(data) {
  return request({
    url: `/api/v1/quarterlyPhysicalExamination/add`,
    method: "post",
    data,
  });
}

//编辑
export function editQuarterlyPhysicalExamination(data) {
  return request({
    url: `/api/v1/quarterlyPhysicalExamination/edit`,
    method: "post",
    data,
  });
}
//删除
export function deleteQuarterlyPhysicalExamination(data) {
  return request({
    url: `/api/v1/quarterlyPhysicalExamination/delete`,
    method: "delete",
    data,
  });
}

//详情
export function getQuarterlyPhysicalExaminationsItem(params) {
  return request({
    url: `/api/v1/quarterlyPhysicalExaminations/${params.key}`,
    method: "get",
    params,
  });
}

//100、预警

// 列表
export function getExitVisaTrackings(params) {
  return request({
    url: `/api/v1/exitVisaTrackings`,
    method: "get",
    params,
  });
}

//导出
export function exportExitVisaTrackings(params) {
  return request({
    url: `/api/v1/exitVisaTrackings/export`,
    method: "get",
    params,
  });
}

//详情
export function getExitVisaTrackingsItem(params) {
  return request({
    url: `/api/v1/exitVisaTrackings/${params.key}`,
    method: "get",
    params,
  });
}

//读取数据
export function setDocRecognition(data) {
  return request({
    url: `/api/v1/exitVisaTrackings/DocRecognition`,
    method: "post",
    data,
  });
}

//有效机票
export function getExitVisaTracking(params) {
  return request({
    url: `/api/v1/exitVisaTracking/tickets`,
    method: "get",
    params,
  });
}

//修改机票
export function getFlightTicketTracking(data) {
  return request({
    url: `/api/v1/exitVisaTrackings/flightTicket/update`,
    method: "post",
    data,
  });
}

//修改签证
export function updateExitVisaTrackings(data) {
  return request({
    url: `/api/v1/exitVisaTrackings/update`,
    method: "post",
    data,
  });
}

//取消预警
export function setExitVisaTrackings(data) {
  return request({
    url: `/api/v1/exitVisaTrackings/warning/set`,
    method: "post",
    data,
  });
}

//101、票务代理引入申请

// 列表
export function getNewTicketingAgentApplications(params) {
  return request({
    url: `/api/v1/newTicketingAgentApplications`,
    method: "get",
    params,
  });
}

//添加
export function addNewTicketingAgentApplication(data) {
  return request({
    url: `/api/v1/newTicketingAgentApplication/add`,
    method: "post",
    data,
  });
}

//修改
export function editNewTicketingAgentApplication(data) {
  return request({
    url: `/api/v1/newTicketingAgentApplication/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteNewTicketingAgentApplication(data) {
  return request({
    url: `/api/v1/newTicketingAgentApplication/delete`,
    method: "delete",
    data,
  });
}

//详情
export function getNewTicketingAgentApplicationItem(params) {
  return request({
    url: `/api/v1/newTicketingAgentApplications/${params.key}`,
    method: "get",
    params,
  });
}

//102、票务代理档案管理

// 列表
export function getTicketingAgents(params) {
  return request({
    url: `/api/v1/ticketingAgents`,
    method: "get",
    params,
  });
}

//新增
export function addTicketingAgent(data) {
  return request({
    url: `/api/v1/ticketingAgent/add`,
    method: "post",
    data,
  });
}

//编辑
export function editTicketingAgent(data) {
  return request({
    url: `/api/v1/ticketingAgent/edit`,
    method: "post",
    data,
  });
}

//详情
export function getTicketingAgentsItem(params) {
  return request({
    url: `/api/v1/ticketingAgents/${params.key}`,
    method: "get",
    params,
  });
}

//导入模板
export function templateTicketingAgent(params) {
  return request({
    url: `/api/v1/ticketingAgent/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importTicketingAgent(data) {
  return request({
    url: `/api/v1/ticketingAgent/import`,
    method: "post",
    data,
  });
}

//导出
export function exportTicketingAgent(params) {
  return request({
    url: `/api/v1/ticketingAgent/export`,
    method: "get",
    params,
  });
}
//删除
export function deleteTicketingAgent(data) {
  return request({
    url: `/api/v1/ticketingAgent/delete`,
    method: "delete",
    data,
  });
}

//103、票务代理考核管理

// 列表
export function getTicketingAgentAssessments(params) {
  return request({
    url: `/api/v1/ticketingAgentAssessments`,
    method: "get",
    params,
  });
}
// 详情
export function getTicketingAgentAssessmentsItem(params) {
  return request({
    url: `/api/v1/ticketingAgentAssessments/${params.key}`,
    method: "get",
    params,
  });
}

//添加
export function addTicketingAgentAssessment(data) {
  return request({
    url: `/api/v1/ticketingAgentAssessment/add`,
    method: "post",
    data,
  });
}

//编辑
export function editTicketingAgentAssessment(data) {
  return request({
    url: `/api/v1/ticketingAgentAssessment/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteTicketingAgentAssessment(data) {
  return request({
    url: `/api/v1/ticketingAgentAssessment/delete`,
    method: "delete",
    data,
  });
}

//导入
export function importTicketingAgentAssessment(data) {
  return request({
    url: `/api/v1/ticketingAgentAssessment/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateTicketingAgentAssessment(params) {
  return request({
    url: `/api/v1/ticketingAgentAssessment/import/template`,
    method: "get",
    params,
  });
}

//103、票务代理奖惩管理

// 列表
export function getTicketingAgentRewardAndDisciplines(params) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDisciplines`,
    method: "get",
    params,
  });
}

// 详情
export function getTicketingAgentRewardAndDisciplinesItem(params) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDisciplines/${params.key}`,
    method: "get",
    params,
  });
}

//添加
export function addTicketingAgentRewardAndDiscipline(data) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDiscipline/add`,
    method: "post",
    data,
  });
}

//编辑
export function editTicketingAgentRewardAndDiscipline(data) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDiscipline/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteTicketingAgentRewardAndDiscipline(data) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDiscipline/delete`,
    method: "delete",
    data,
  });
}

//导入
export function importTicketingAgentRewardAndDiscipline(data) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDiscipline/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateTicketingAgentRewardAndDiscipline(params) {
  return request({
    url: `/api/v1/ticketingAgentRewardAndDiscipline/import/template`,
    method: "get",
    params,
  });
}

//104、费用明细
// 列表
export function getTicketFareDetails(params) {
  return request({
    url: `/api/v1/ticketFareDetails`,
    method: "get",
    params,
  });
}

//确认付费
export function confirmTicketFareDetail(data) {
  return request({
    url: `/api/v1/ticketFareDetail/confirm`,
    method: "post",
    data,
  });
}

//付费汇总
export function summaryTicketFareDetail(data) {
  return request({
    url: `/api/v1/ticketFareDetail/summary`,
    method: "post",
    data,
  });
}

//105、费用明细汇总
export function getTicketFareSummaryApplicationDetails(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplicationDetails`,
    method: "get",
    params,
  });
}
//105、费用明细汇总详情
export function getTicketFareSummaryApplicationDetailsitem(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplicationDetails/${params.key}`,
    method: "get",
    params,
  });
}

//导出
export function exportTicketFareSummaryApplicationDetail(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplicationDetail/export`,
    method: "get",
    params,
  });
}

//删除
export function deleteTicketFareSummaryApplicationDetail(data) {
  return request({
    url: `/api/v1/ticketFareSummaryApplicationDetail/delete`,
    method: "delete",
    data,
  });
}

//费用明细汇总明细

export function getTicketFareSummaryApplicationDetailsTicketFares(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplicationDetail/ticketFares`,
    method: "get",
    params,
  });
}

//费用明细汇总明细导出

export function exportTicketFareSummaryApplicationDetailTicketFare(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplicationDetail/ticketFare/export`,
    method: "get",
    params,
  });
}

// 106、费用汇总审批
export function getTicketFareSummaryApplications(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplications`,
    method: "get",
    params,
  });
}
//修改币种
export function putTicketFareSummaryApplicationsCurrency(data) {
  return request({
    url: `/api/v1/ticketFareSummaryApplication/currency/put`,
    method: "post",
    data,
  });
}

///

export function pendingTicketFareSummaryApplication(params) {
  return request({
    url: `api/v1/ticketFareSummaryApplication/pending`,
    method: "get",
    params,
  });
}

export function deleteTicketFareSummaryApplication(data) {
  return request({
    url: `/api/v1/ticketFareSummaryApplication/delete`,
    method: "delete",
    data,
  });
}

export function addTicketFareSummaryApplication(data) {
  return request({
    url: `/api/v1/ticketFareSummaryApplication/add`,
    method: "post",
    data,
  });
}

export function editTicketFareSummaryApplication(data) {
  return request({
    url: `/api/v1/ticketFareSummaryApplication/edit`,
    method: "post",
    data,
  });
}

export function getTicketFareSummaryApplicationItem(params) {
  return request({
    url: `/api/v1/ticketFareSummaryApplications/${params.key}`,
    method: "get",
    params,
  });
}

//
export function getTicketFareTicketingAgents(params) {
  return request({
    url: `/api/v1/ticketFareDetail/ticketingAgents`,
    method: "get",
    params,
  });
}

//107、员工履历表
export function getEmployeeCareerRecords(params) {
  return request({
    url: `/api/v1/employeeCareerRecords`,
    method: "get",
    params,
  });
}

export function getEmployeeCareerRecordsItem(params) {
  return request({
    url: `/api/v1/employeeCareerRecords/${params.userCode}`,
    method: "get",
    params,
  });
}

//108、专业

//获取全部
export function allMajors(params) {
  return request({
    url: `/api/v1/major/all`,
    method: "get",
    params,
  });
}
//列表
export function getMajors(params) {
  return request({
    url: `/api/v1/majors`,
    method: "get",
    params,
  });
}

//新增
export function addMajors(data) {
  return request({
    url: `/api/v1/major/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateMajors(data) {
  return request({
    url: `/api/v1/major/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteMajors(data) {
  return request({
    url: `/api/v1/major/delete`,
    method: "delete",
    data,
  });
}

//109、学位

//获取全部
export function allDegrees(params) {
  return request({
    url: `/api/v1/degree/all`,
    method: "get",
    params,
  });
}

//列表
export function getDegrees(params) {
  return request({
    url: `/api/v1/degrees`,
    method: "get",
    params,
  });
}

//新增
export function addDegrees(data) {
  return request({
    url: `/api/v1/degree/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateDegrees(data) {
  return request({
    url: `/api/v1/degree/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteDegrees(data) {
  return request({
    url: `/api/v1/degree/delete`,
    method: "delete",
    data,
  });
}

//110、学历

//获取全部
export function allEducations(params) {
  return request({
    url: `/api/v1/education/all`,
    method: "get",
    params,
  });
}

//列表
export function getEducations(params) {
  return request({
    url: `/api/v1/educations`,
    method: "get",
    params,
  });
}

//新增
export function addEducation(data) {
  return request({
    url: `/api/v1/education/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateEducation(data) {
  return request({
    url: `/api/v1/education/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEducation(data) {
  return request({
    url: `/api/v1/education/delete`,
    method: "delete",
    data,
  });
}

//111、毕业院校

//获取全部
export function allSchools(params) {
  return request({
    url: `/api/v1/school/all`,
    method: "get",
    params,
  });
}

//列表
export function getSchools(params) {
  return request({
    url: `/api/v1/schools`,
    method: "get",
    params,
  });
}

//新增
export function addSchool(data) {
  return request({
    url: `/api/v1/school/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateSchool(data) {
  return request({
    url: `/api/v1/school/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteSchool(data) {
  return request({
    url: `/api/v1/school/delete`,
    method: "delete",
    data,
  });
}

//112、教育背景
export function getEmployeeEducationBackgrounds(params) {
  return request({
    url: `/api/v1/employeeEducationBackgrounds`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeEducationBackground(data) {
  return request({
    url: `/api/v1/employeeEducationBackground/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateEmployeeEducationBackground(data) {
  return request({
    url: `/api/v1/employeeEducationBackground/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeEducationBackground(data) {
  return request({
    url: `/api/v1/employeeEducationBackground/delete`,
    method: "delete",
    data,
  });
}

//导入模板
export function templateEmployeeEducationBackground(params) {
  return request({
    url: `/api/v1/employeeEducationBackground/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeEducationBackground(data) {
  return request({
    url: `/api/v1/employeeEducationBackground/import`,
    method: "post",
    data,
  });
}

//导出
export function exportEmployeeEducationBackground(params) {
  return request({
    url: `/api/v1/employeeEducationBackground/export`,
    method: "get",
    params,
  });
}

//113、奖惩情况

export function getEmployeeRewardandPenaltyRecords(params) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecords`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeRewardandPenaltyRecord(data) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecord/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateEmployeeRewardandPenaltyRecord(data) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecord/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeRewardandPenaltyRecord(data) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecord/delete`,
    method: "delete",
    data,
  });
}

//导入模板
export function templateEmployeeRewardandPenaltyRecord(params) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecord/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeRewardandPenaltyRecord(data) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecord/import`,
    method: "post",
    data,
  });
}

//导出
export function exportEmployeeRewardandPenaltyRecord(params) {
  return request({
    url: `/api/v1/employeeRewardandPenaltyRecord/export`,
    method: "get",
    params,
  });
}

// 114 当地驾照新办审批
// 列表
export function getIssueNewDrivingLicenseApplications2(params) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addIssueNewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editIssueNewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getIssueNewDrivingLicenseApplicationsItem(params) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payIssueNewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeIssueNewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteIssueNewDrivingLicenseApplication(params) {
  return request({
    url: `/api/v1/issueNewDrivingLicenseApplication/delete`,
    method: "delete",
    params,
  });
}

// 115 当地驾照延期审批
// 列表
export function getRenewDrivingLicenseApplications2(params) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplications2`,
    method: "get",
    params,
  });
}

//新增
export function addRenewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editRenewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplication/edit`,
    method: "post",
    data,
  });
}

//详情
export function getRenewDrivingLicenseApplicationItem(params) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplications/${params.key}`,
    method: "get",
    params,
  });
}

//付费
export function payRenewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplication/pay`,
    method: "post",
    data,
  });
}

//办结
export function completeRenewDrivingLicenseApplication(data) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplication/complete`,
    method: "post",
    data,
  });
}

//删除
export function deleteRenewDrivingLicenseApplication(params) {
  return request({
    url: `/api/v1/renewDrivingLicenseApplication/delete`,
    method: "delete",
    params,
  });
}

// 116 驾照信息管理

//列表
export function getDrivingLicenses(params) {
  return request({
    url: `/api/v1/drivingLicenses`,
    method: "get",
    params,
  });
}

//导出
export function exportDrivingLicenses(params) {
  return request({
    url: `/api/v1/drivingLicense/export`,
    method: "get",
    params,
  });
}

//导入
export function importDrivingLicenses(data) {
  return request({
    url: `/api/v1/drivingLicense/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateDrivingLicenses(params) {
  return request({
    url: `/api/v1/drivingLicense/import/template`,
    method: "get",
    params,
  });
}

//处理
export function processDrivingLicenses(data) {
  return request({
    url: `/api/v1/drivingLicense/process`,
    method: "post",
    data,
  });
}

//删除
export function deleteDrivingLicenses(data) {
  return request({
    url: `/api/v1/drivingLicense/delete`,
    method: "delete",
    data,
  });
}

// 117 暂住证有效期预警

//列表
export function getIqamas(params) {
  return request({
    url: `/api/v1/iqamas`,
    method: "get",
    params,
  });
}

//导出
export function exportIqama(params) {
  return request({
    url: `/api/v1/iqama/export`,
    method: "get",
    params,
  });
}

//导入
export function importIqama(data) {
  return request({
    url: `/api/v1/iqama/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateIqama(params) {
  return request({
    url: `/api/v1/iqama/import/template`,
    method: "get",
    params,
  });
}

//删除
export function deleteIqama(data) {
  return request({
    url: `/api/v1/iqama/delete`,
    method: "delete",
    data,
  });
}
//处理
export function processIqama(data) {
  return request({
    url: `/api/v1/iqama/process`,
    method: "post",
    data,
  });
}

//附件
export function fileIqama(data) {
  return request({
    url: `/api/v1/iqama/file`,
    method: "post",
    data,
  });
}

//
export function logsIqama(params) {
  return request({
    url: `/api/v1/iqama/logs`,
    method: "get",
    params,
  });
}

// 118 护照信息管理

//列表
export function getPassports(params) {
  return request({
    url: `/api/v1/passports`,
    method: "get",
    params,
  });
}

//导出
export function exportPassport(params) {
  return request({
    url: `/api/v1/passport/export`,
    method: "get",
    params,
  });
}

//导入
export function importPassport(data) {
  return request({
    url: `/api/v1/passport/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templatePassport(params) {
  return request({
    url: `/api/v1/passport/import/template`,
    method: "get",
    params,
  });
}

//删除
export function deletePassport(data) {
  return request({
    url: `/api/v1/passport/delete`,
    method: "delete",
    data,
  });
}
//处理
export function processPassport(data) {
  return request({
    url: `/api/v1/passport/process`,
    method: "post",
    data,
  });
}

//附件
export function filePassport(data) {
  return request({
    url: `/api/v1/passport/file`,
    method: "post",
    data,
  });
}

//
export function logsPassport(params) {
  return request({
    url: `/api/v1/passport/logs`,
    method: "get",
    params,
  });
}

// 119 出险记录

//列表
export function getEmployeePersonalAccidentInsuranceClaimRecords(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceClaimRecords`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeePersonalAccidentInsuranceClaimRecords(params) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceClaimRecord/export`,
    method: "get",
    params,
  });
}

//编辑
export function editEmployeePersonalAccidentInsuranceClaimRecords(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceClaimRecords/edit`,
    method: "post",
    data,
  });
}

//新增
export function addEmployeePersonalAccidentInsuranceClaimRecords(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceClaimRecords/add`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeePersonalAccidentInsuranceClaimRecords(data) {
  return request({
    url: `/api/v1/employeePersonalAccidentInsuranceClaimRecords/delete`,
    method: "delete",
    data,
  });
}

// 120 员工常规体检指数标准

//列表
export function getEmployeePhysicalExamMetrics(params) {
  return request({
    url: `/api/v1/employeePhysicalExamMetrics`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeePhysicalExamMetrics(data) {
  return request({
    url: `/api/v1/employeePhysicalExamMetric/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateEmployeePhysicalExamMetrics(data) {
  return request({
    url: `/api/v1/employeePhysicalExamMetric/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeePhysicalExamMetrics(data) {
  return request({
    url: `/api/v1/employeePhysicalExamMetric/delete`,
    method: "delete",
    data,
  });
}

// 121 干系人管理

//全部
export function getCompanyStakeholderTypeAll(params) {
  return request({
    url: `/api/v1/companyStakeholderType/all`,
    method: "get",
    params,
  });
}

//列表
export function getCompanyStakeholderType(params) {
  return request({
    url: `/api/v1/companyStakeholderTypes`,
    method: "get",
    params,
  });
}

//新增

export function addCompanyStakeholderType(data) {
  return request({
    url: `/api/v1/companyStakeholderType/add`,
    method: "post",
    data,
  });
}

//编辑

export function updateCompanyStakeholderType(data) {
  return request({
    url: `/api/v1/companyStakeholderType/update`,
    method: "post",
    data,
  });
}

//删除

export function deleteCompanyStakeholderType(data) {
  return request({
    url: `/api/v1/companyStakeholderType/delete`,
    method: "delete",
    data,
  });
}

// 122 部门属性

//全部
export function getDepartmentTypeAll(params) {
  return request({
    url: `/api/v1/departmentType/all`,
    method: "get",
    params,
  });
}

//列表
export function getDepartmentType(params) {
  return request({
    url: `/api/v1/departmentTypes`,
    method: "get",
    params,
  });
}

//新增

export function addDepartmentType(data) {
  return request({
    url: `/api/v1/departmentType/add`,
    method: "post",
    data,
  });
}

//编辑

export function updateDepartmentType(data) {
  return request({
    url: `/api/v1/departmentType/update`,
    method: "post",
    data,
  });
}

//删除

export function deleteDepartmentType(data) {
  return request({
    url: `/api/v1/departmentType/delete`,
    method: "delete",
    data,
  });
}

// 123 政务平台

//列表
export function getDigitalGovernmentPlatforms(params) {
  return request({
    url: `/api/v1/digitalGovernmentPlatforms`,
    method: "get",
    params,
  });
}

//详情
export function getDigitalGovernmentPlatformsItem(params) {
  return request({
    url: `/api/v1/digitalGovernmentPlatforms/${params.id}`,
    method: "get",
    params,
  });
}

//导入
export function importDigitalGovernmentPlatform(data) {
  return request({
    url: `/api/v1/digitalGovernmentPlatform/import`,
    method: "post",
    data,
  });
}

//导入模板
export function templateDigitalGovernmentPlatform(params) {
  return request({
    url: `/api/v1/digitalGovernmentPlatform/import/template`,
    method: "get",
    params,
  });
}

//导出
export function exportDigitalGovernmentPlatform(params) {
  return request({
    url: `/api/v1/digitalGovernmentPlatform/export`,
    method: "get",
    params,
  });
}

//新增
export function addDigitalGovernmentPlatform(data) {
  return request({
    url: `/api/v1/digitalGovernmentPlatform/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateDigitalGovernmentPlatform(data) {
  return request({
    url: `/api/v1/digitalGovernmentPlatform/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteDigitalGovernmentPlatform(data) {
  return request({
    url: `/api/v1/digitalGovernmentPlatform/delete`,
    method: "delete",
    data,
  });
}

// 124 岗位子类别

//全部
export function getPositionSubCategoryAll(params) {
  return request({
    url: `/api/v1/positionSubCategory/all`,
    method: "get",
    params,
  });
}

//列表
export function getPositionSubCategory(params) {
  return request({
    url: `/api/v1/positionSubCategories`,
    method: "get",
    params,
  });
}

//新增
export function addPositionSubCategory(data) {
  return request({
    url: `/api/v1/positionSubCategory/add`,
    method: "post",
    data,
  });
}

//编辑
export function updatePositionSubCategory(data) {
  return request({
    url: `/api/v1/positionSubCategory/update`,
    method: "post",
    data,
  });
}

//删除
export function deletePositionSubCategory(params) {
  return request({
    url: `/api/v1/positionSubCategory/delete`,
    method: "delete",
    params,
  });
}

//125、访问签证

//列表
export function getVisitVisaTrackings(params) {
  return request({
    url: `/api/v1/visitVisaTrackings`,
    method: "get",
    params,
  });
}

//详情
export function getVisitVisaTrackingsItem(params) {
  return request({
    url: `/api/v1/visitVisaTrackings/${params.key}`,
    method: "get",
    params,
  });
}

//导入
export function importVisitVisaTracking(data) {
  return request({
    url: `/api/v1/visitVisaTracking/import`,
    method: "post",
    data,
  });
}

// 导入模板

export function templateVisitVisaTracking(params) {
  return request({
    url: `/api/v1/visitVisaTracking/import/template`,
    method: "get",
    params,
  });
}

// 导出
export function exportVisitVisaTracking(params) {
  return request({
    url: `/api/v1/visitVisaTracking/export`,
    method: "get",
    params,
  });
}

//修改
export function processVisitVisaTracking(data) {
  return request({
    url: `/api/v1/visitVisaTracking/process`,
    method: "post",
    data,
  });
}

//签证
export function updateVisitVisaTracking(data) {
  return request({
    url: `/api/v1/visitVisaTracking/update`,
    method: "post",
    data,
  });
}

export function docRecognitionVisitVisaTracking(data) {
  return request({
    url: `/api/v1/visitVisaTracking/DocRecognition`,
    method: "post",
    data,
  });
}

export function ticketsVisitVisaTracking(params) {
  return request({
    url: `/api/v1/visitVisaTracking/tickets`,
    method: "get",
    params,
  });
}

export function flightTicketVisitVisaTracking(data) {
  return request({
    url: `/api/v1/visitVisaTracking/flightTicket/update`,
    method: "post",
    data,
  });
}

export function setVisitVisaTracking(data) {
  return request({
    url: `/api/v1/visitVisaTracking/warning/set`,
    method: "post",
    data,
  });
}

//126、任务批件

//列表
export function getTaskApprovalDocuments(params) {
  return request({
    url: `/api/v1/taskApprovalDocuments`,
    method: "get",
    params,
  });
}

//导出
export function exportTaskApprovalDocument(params) {
  return request({
    url: `/api/v1/taskApprovalDocument/export`,
    method: "get",
    params,
  });
}

//编辑
export function updateTaskApprovalDocument(data) {
  return request({
    url: `/api/v1/taskApprovalDocument/remark/update`,
    method: "post",
    data,
  });
}

//127、外事证照交接记录

//列表
export function getDocumentTransfers(params) {
  return request({
    url: `/api/v1/documentTransfers`,
    method: "get",
    params,
  });
}

//详情
export function getDocumentTransfersItem(params) {
  return request({
    url: `/api/v1/documentTransfers/${params.id}`,
    method: "get",
    params,
  });
}

//导出
export function exportDocumentTransfers(params) {
  return request({
    url: `/api/v1/documentTransfer/export`,
    method: "get",
    params,
  });
}

//下载模板
export function templateDocumentTransfers(params) {
  return request({
    url: `/api/v1/documentTransfer/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importDocumentTransfers(data) {
  return request({
    url: `/api/v1/documentTransfer/import`,
    method: "post",
    data,
  });
}

//新增
export function addDocumentTransfers(data) {
  return request({
    url: `/api/v1/documentTransfer/add`,
    method: "post",
    data,
  });
}

//编辑
export function editDocumentTransfers(data) {
  return request({
    url: `/api/v1/documentTransfer/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteDocumentTransfers(data) {
  return request({
    url: `/api/v1/documentTransfer/delete`,
    method: "delete",
    data,
  });
}

//128、外事证照交接记录

//列表
export function getForeignAffairsStats(params) {
  return request({
    url: `/api/v1/foreignAffairsStats`,
    method: "get",
    params,
  });
}

//查找统计子记录
export function getForeignAffairsStatsChildren(params) {
  return request({
    url: `/api/v1/foreignAffairsStats/${params.id}/children`,
    method: "get",
    params,
  });
}

//列表
export function exportForeignAffairsStats(params) {
  return request({
    url: `/api/v1/foreignAffairsStats/export`,
    method: "get",
    params,
  });
}

//129、员工年度考勤汇总表,中国籍非直聘

// 列表
export function getChineseEmployeeAttendances(params) {
  return request({
    url: `/api/v1/chineseEmployeeAttendances`,
    method: "get",
    params,
  });
}

//导出
export function exportChineseEmployeeAttendances(params) {
  return request({
    url: `/api/v1/chineseEmployeeAttendance/export`,
    method: "get",
    params,
  });
}

//130、员工年度考勤汇总表,中国籍直聘

// 列表
export function getChineseLocalEmployeeAttendance(params) {
  return request({
    url: `/api/v1/chineseLocalEmployeeAttendances`,
    method: "get",
    params,
  });
}

//导出
export function exportChineseLocalEmployeeAttendance(params) {
  return request({
    url: `/api/v1/chineseLocalEmployeeAttendance/export`,
    method: "get",
    params,
  });
}
//131、员工年度考勤汇总表,外籍

// 列表
export function getForeignEmployeeAttendances(params) {
  return request({
    url: `/api/v1/foreignEmployeeAttendances`,
    method: "get",
    params,
  });
}

//导出
export function exportForeignEmployeeAttendance(params) {
  return request({
    url: `/api/v1/foreignEmployeeAttendance/export`,
    method: "get",
    params,
  });
}

//132、员工年度考勤汇总表,外籍

// 列表
export function getTicketFarePaymentSummaryApplicationDetails(params) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplicationDetails`,
    method: "get",
    params,
  });
}

//
export function pendingTicketFarePaymentSummaryApplications(params) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplication/pending`,
    method: "get",
    params,
  });
}

export function deleteTicketFarePaymentSummaryApplications(data) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplicationDetail/delete`,
    method: "delete",
    data,
  });
}

export function addTicketFarePaymentSummaryApplications(data) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplication/add`,
    method: "post",
    data,
  });
}

export function editTicketFarePaymentSummaryApplications(data) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplication/edit`,
    method: "post",
    data,
  });
}
export function putTicketFarePaymentSummaryApplicationCurrency(data) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplication/currency/put`,
    method: "post",
    data,
  });
}

//导出
export function exportTicketFarePaymentSummaryApplicationDetails(params) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplicationDetail/export`,
    method: "get",
    params,
  });
}

//133、费用明细汇总付款单明细

// 列表
export function getTicketFarePaymentSummaryApplicationDetailsTicketFares(
  params,
) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplicationDetail/ticketFares`,
    method: "get",
    params,
  });
}

//导出
export function exportTicketFarePaymentSummaryApplicationDetailsTicketFares(
  params,
) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplicationDetail/export`,
    method: "get",
    params,
  });
}

export function getTicketFarePaymentSummaryApplications(params) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplications`,
    method: "get",
    params,
  });
}

export function getTicketFarePaymentSummaryApplicationsItem(params) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplication/${params.key}`,
    method: "get",
    params,
  });
}

//

export function deleteTicketFarePaymentSummaryApplicationsItem(data) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplication/delete`,
    method: "delete",
    data,
  });
}

export function getTicketFarePaymentSummaryApplicationDetailsItem(params) {
  return request({
    url: `/api/v1/ticketFarePaymentSummaryApplicationDetails/${params.key}`,
    method: "get",
    params,
  });
}

// 134、票务统计分析

export function getTicketBookingStats(data) {
  return request({
    url: `/api/v1/ticketBookingStats`,
    method: "post",
    data,
  });
}

export function exportTicketBookingStats(data) {
  return request({
    url: `/api/v1/ticketBookingStats/export`,
    method: "post",
    data,
  });
}

// 135、票价分析1
export function getTicketFareStats1(data) {
  return request({
    url: `/api/v1/ticketFareStats1`,
    method: "post",
    data,
  });
}

export function exportTicketFareStats1(data) {
  return request({
    url: `/api/v1/ticketFareStats1/export`,
    method: "post",
    data,
  });
}

export function getTicketFareStats2(data) {
  return request({
    url: `/api/v1/ticketFareStats2`,
    method: "post",
    data,
  });
}

// 136、岗位沙化分类管理

export function getSaudizationGroups(params) {
  return request({
    url: `/api/v1/saudizationGroups`,
    method: "get",
    params,
  });
}

export function getSaudizationGroupsAll(params) {
  return request({
    url: `/api/v1/saudizationGroup/all`,
    method: "get",
    params,
  });
}

export function addSaudizationGroup(data) {
  return request({
    url: `/api/v1/saudizationGroup/add`,
    method: "post",
    data,
  });
}

export function updateSaudizationGroup(data) {
  return request({
    url: `/api/v1/saudizationGroup/update`,
    method: "post",
    data,
  });
}

export function deleteSaudizationGroup(data) {
  return request({
    url: `/api/v1/saudizationGroup/delete`,
    method: "delete",
    data,
  });
}

// 137、岗位层级

export function getPositionLevels(params) {
  return request({
    url: `/api/v1/positionLevels`,
    method: "get",
    params,
  });
}

export function addPositionLevel(data) {
  return request({
    url: `/api/v1/positionLevel/add`,
    method: "post",
    data,
  });
}

export function updatePositionLevel(data) {
  return request({
    url: `/api/v1/positionLevel/update`,
    method: "post",
    data,
  });
}

export function deletePositionLevel(data) {
  return request({
    url: `/api/v1/positionLevel/delete`,
    method: "delete",
    data,
  });
}

// 138、GOSI工伤报告

//列表
export function getPersonalInjurySiteGOSIInformationApplications(params) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationApplications`,
    method: "get",
    params,
  });
}

//详情
export function getPersonalInjurySiteGOSIInformationApplicationItem(params) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationApplications/${params.key}`,
    method: "get",
    params,
  });
}

//添加
export function addPersonalInjurySiteGOSIInformationApplication(data) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editPersonalInjurySiteGOSIInformationApplication(data) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationApplication/edit`,
    method: "post",
    data,
  });
}

//删除
export function deletePersonalInjurySiteGOSIInformationApplication(data) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationApplication/delete`,
    method: "delete",
    data,
  });
}

// 139、GOSI理赔台账
export function getPersonalInjurySiteGOSIInformationAccountings(params) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationAccountings`,
    method: "get",
    params,
  });
}

export function exportPersonalInjurySiteGOSIInformationAccountings(params) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationAccounting/export`,
    method: "get",
    params,
  });
}

export function updatePersonalInjurySiteGOSIInformationAccountings(data) {
  return request({
    url: `/api/v1/personalInjurySiteGOSIInformationAccounting/update`,
    method: "post",
    data,
  });
}

// 140、中国籍当地社保等级标准

//列表
export function getEmployeeSocialInsuranceClassLevels(params) {
  return request({
    url: `/api/v1/employeeSocialInsuranceClassLevels`,
    method: "get",
    params,
  });
}

//全部
export function getEmployeeSocialInsuranceClassLevelsAll(params) {
  return request({
    url: `/api/v1/employeeSocialInsuranceClassLevel/all`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeSocialInsuranceClassLevel(data) {
  return request({
    url: `/api/v1/employeeSocialInsuranceClassLevel/add`,
    method: "post",
    data,
  });
}
//编辑
export function updateEmployeeSocialInsuranceClassLevel(data) {
  return request({
    url: `/api/v1/employeeSocialInsuranceClassLevel/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeSocialInsuranceClassLevel(data) {
  return request({
    url: `/api/v1/employeeSocialInsuranceClassLevel/delete`,
    method: "delete",
    data,
  });
}

// 141、员工社保信息管理

//列表
export function getEmployeeSocialInsurances(params) {
  return request({
    url: `/api/v1/employeeSocialInsurances`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeeSocialInsurances(params) {
  return request({
    url: `/api/v1/employeeSocialInsurance/export`,
    method: "get",
    params,
  });
}

//导入模板
export function templateEmployeeSocialInsurances(params) {
  return request({
    url: `/api/v1/employeeSocialInsurance/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeSocialInsurance(data) {
  return request({
    url: `/api/v1/employeeSocialInsurance/import`,
    method: "post",
    data,
  });
}
export function processEmployeeSocialInsurance(data) {
  return request({
    url: `/api/v1/employeeSocialInsurance/process`,
    method: "post",
    data,
  });
}
export function deleteEmployeeSocialInsurance(data) {
  return request({
    url: `/api/v1/employeeSocialInsurance/delete`,
    method: "delete",
    data,
  });
}

// 142、员工社保注册审批

//列表
export function getEmployeeWagestoGOSIApplictions2(params) {
  return request({
    url: `/api/v1/employeeWagestoGOSIApplictions2`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeeWagestoGOSIAppliction(params) {
  return request({
    url: `/api/v1/employeeWagestoGOSIAppliction/export`,
    method: "get",
    params,
  });
}
//详情
export function getEmployeeWagestoGOSIApplictionItem(params) {
  return request({
    url: `/api/v1/employeeWagestoGOSIApplictions/${params.key}`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeWagestoGOSIApplictions(data) {
  return request({
    url: `/api/v1/employeeWagestoGOSIAppliction/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeWagestoGOSIApplictions(data) {
  return request({
    url: `/api/v1/employeeWagestoGOSIAppliction/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeWagestoGOSIApplictions(data) {
  return request({
    url: `/api/v1/employeeWagestoGOSIAppliction/delete`,
    method: "delete",
    data,
  });
}

//办结
export function completeEmployeeWagestoGOSIApplictions(data) {
  return request({
    url: `/api/v1/employeeWagestoGOSIAppliction/complete`,
    method: "post",
    data,
  });
}

// 143、定期休假规则

//列表
export function getEmployeeLeavePolicies(params) {
  return request({
    url: `/api/v1/employeeLeavePolicies`,
    method: "get",
    params,
  });
}

//下载模板
export function templateEmployeeLeavePolicies(params) {
  return request({
    url: `/api/v1/employeeLeavePolicy/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeLeavePolicies(data) {
  return request({
    url: `/api/v1/employeeLeavePolicy/import`,
    method: "post",
    data,
  });
}

//更新
export function updateEmployeeLeavePolicies1(data) {
  return request({
    url: `/api/v1/employeeLeavePolicy/update`,
    method: "post",
    data,
  });
}

//更新
export function updateEmployeeLeavePolicies2(data) {
  return request({
    url: `/api/v1/employeeLeavePolicy/dynamicDays/update`,
    method: "post",
    data,
  });
}

//机票历史
export function getTicketLogs(params) {
  return request({
    url: `/api/v1/employeeLeavePolicy/ticketLogs`,
    method: "get",
    params,
  });
}

// 144、休假台账

export function getEmployeeLeaveAccountings(params) {
  return request({
    url: `/api/v1/employeeLeaveAccountings`,
    method: "get",
    params,
  });
}

export function exportEmployeeLeaveAccountings(params) {
  return request({
    url: `/api/v1/employeeLeaveAccountings/export`,
    method: "get",
    params,
  });
}
// 145、费用项目管理

export function getCostCategoriesAll(params) {
  return request({
    url: `/api/v1/costCategory/all`,
    method: "get",
    params,
  });
}

export function getCostCategories(params) {
  return request({
    url: `/api/v1/costCategories`,
    method: "get",
    params,
  });
}

export function getCostCategoriesChildren(params) {
  return request({
    url: `/api/v1/costCategories/${params.id}/children`,
    method: "get",
    params,
  });
}

export function getCostCategoriesTree(data) {
  return request({
    url: `/api/v1/costCategory/tree`,
    method: "post",
    data,
  });
}

export function getCostCategorieRoot(params) {
  return request({
    url: `/api/v1/costCategory/root`,
    method: "get",
    params,
  });
}

export function addCostCategories(data) {
  return request({
    url: `/api/v1/costCategory/add`,
    method: "post",
    data,
  });
}

export function updateCostCategories(data) {
  return request({
    url: `/api/v1/costCategory/update`,
    method: "post",
    data,
  });
}

export function deleteCostCategories(data) {
  return request({
    url: `/api/v1/costCategory/delete`,
    method: "delete",
    data,
  });
}
// 146、费用归集管理

//全部
export function getCostPoolCategoryAll(params) {
  return request({
    url: `/api/v1/costPoolCategory/all`,
    method: "get",
    params,
  });
}

//列表

export function getCostPoolCategorys(params) {
  return request({
    url: `/api/v1/costPoolCategories`,
    method: "get",
    params,
  });
}

//新增
export function addCostPoolCategory(data) {
  return request({
    url: `/api/v1/costPoolCategory/add`,
    method: "post",
    data,
  });
}
//编辑
export function updateCostPoolCategory(data) {
  return request({
    url: `/api/v1/costPoolCategory/update`,
    method: "post",
    data,
  });
}

// 删除

export function deleteCostPoolCategory(data) {
  return request({
    url: `/api/v1/costPoolCategory/delete`,
    method: "delete",
    data,
  });
}

// 147、 GOSI费用分割审批 单独

//导入模板
export function templateCostAllocation6(params) {
  return request({
    url: `/api/v1/costAllocation6/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importCostAllocation6(data) {
  return request({
    url: `/api/v1/costAllocation6/import`,
    method: "post",
    data,
  });
}

//详细
export function getCostAllocation6GOSICosts(params) {
  return request({
    url: `/api/v1/costAllocation6/GOSICosts`,
    method: "get",
    params,
  });
}

// GOSI明细导出

export function exportCostAllocation6GOSICosts(params) {
  return request({
    url: `/api/v1/costAllocation6/GOSICost/export`,
    method: "get",
    params,
  });
}

// 148、 费用汇总统计

//列表
export function getCostStats(params) {
  return request({
    url: `/api/v1/costStats`,
    method: "get",
    params,
  });
}

//列表
export function getCostStatsChildren(params) {
  return request({
    url: `/api/v1/costStats/{id}/children`,
    method: "get",
    params,
  });
}

export function editCostStats(data) {
  return request({
    url: `/api/v1/costStats/edit`,
    method: "post",
    data,
  });
}

//导出
export function exportCostStats(params) {
  return request({
    url: `/api/v1/costStats/export`,
    method: "get",
    params,
  });
}

// 149、 费用汇总统计明细

//列表
export function getCostStatsDetails(params) {
  return request({
    url: `/api/v1/costStatsDetails`,
    method: "get",
    params,
  });
}

//导出
export function exportCostStatsDetail(params) {
  return request({
    url: `/api/v1/costStatsDetail/export`,
    method: "get",
    params,
  });
}

// 150、 员工入职登记信息
export function getEmployeeOnboardingInformation(params) {
  return request({
    url: `/api/v1/employeeOnboardingInformation`,
    method: "get",
    params,
  });
}

export function getEmployeeOnboardingInformationItem(params) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/${params.key}`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeOnboardingInformation(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeOnboardingInformation(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeOnboardingInformation(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/delete`,
    method: "delete",
    data,
  });
}

//模板
export function templateEmployeeOnboardingInformation(params) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/import/phase1Template`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeeOnboardingInformation(params) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/export`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeOnboardingInformation(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/phase1Import`,
    method: "post",
    data,
  });
}

export function BasicInfoTemplateEmployeeOnboardingInformation(params) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/import/basicInfoTemplate`,
    method: "get",
    params,
  });
}

export function EmployeeOnboardingInformationImportBasicInfo(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/importBasicInfo`,
    method: "post",
    data,
  });
}

export function JobInfoTemplateEmployeeOnboardingInformation(params) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/import/jobInfoTemplate`,
    method: "get",
    params,
  });
}

export function EmployeeOnboardingInformationImportJobInfo(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/importJobInfo`,
    method: "post",
    data,
  });
}

export function auditEmployeeOnboardingInformation(data) {
  return request({
    url: `/api/v1/employeeOnboardingInformation/audit`,
    method: "post",
    data,
  });
}
// 151、基本信息

export function getBasicInfos(params) {
  return request({
    url: `/api/v1/basicInfos`,
    method: "post",
    params,
  });
}

export function exportBasicInfo(data) {
  return request({
    url: `/api/v1/users/export`,
    method: "post",
    data,
  });
}
export function getBasicInfosItem(params) {
  return request({
    url: `/api/v1/basicInfos/${params.id}`,
    method: "get",
    params,
  });
}

export function blockedBasicInfos(data) {
  return request({
    url: `/api/v1/basicInfos/blocked`,
    method: "post",
    data,
  });
}

export function updateBasicInfos(data) {
  return request({
    url: `/api/v1/basicInfo/update`,
    method: "post",
    data,
  });
}

export function templateBasicInfos(params) {
  return request({
    url: `/api/v1/basicInfo/import/template`,
    method: "get",
    params,
  });
}
export function importBasicInfos(data) {
  return request({
    url: `/api/v1/basicInfo/import`,
    method: "post",
    data,
  });
}
export function importBasicInfosCompleteInfo(data) {
  return request({
    url: `/api/v1/basicInfo/completeInfo/import`,
    method: "post",
    data,
  });
}

export function deleteBasicInfos(data) {
  return request({
    url: `/api/v1/basicInfo/delete`,
    method: "delete",
    data,
  });
}
// 152、资质信息

//列表
export function getEmployeeQualificationsandCompetences(params) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetences`,
    method: "get",
    params,
  });
}

//下载模板
export function templateEmployeeQualificationsandCompetence(params) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetence/import/template`,
    method: "get",
    params,
  });
}

//导出
export function exportEmployeeQualificationsandCompetence(params) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetence/export`,
    method: "get",
    params,
  });
}

//导入
export function importEmployeeQualificationsandCompetence(data) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetence/import`,
    method: "post",
    data,
  });
}

//新增
export function addEmployeeQualificationsandCompetence(data) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetence/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateEmployeeQualificationsandCompetence(data) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetence/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeQualificationsandCompetence(data) {
  return request({
    url: `/api/v1/employeeQualificationsandCompetence/delete`,
    method: "delete",
    data,
  });
}

// 153、工作信息

//列表
export function getJobInfos(params) {
  return request({
    url: `/api/v1/jobInfos`,
    method: "post",
    params,
  });
}

//详情
export function getJobInfosItem(params) {
  return request({
    url: `/api/v1/jobInfos/${params.id}`,
    method: "get",
    params,
  });
}

export function templateJobInfos(params) {
  return request({
    url: `/api/v1/jobInfo/import/template`,
    method: "get",
    params,
  });
}

export function importJobInfos(data) {
  return request({
    url: `/api/v1/jobInfo/import`,
    method: "post",
    data,
  });
}

//导入模板

// 154、资格能力
//列表
export function getQualificationsandCompetenceInfos(params) {
  return request({
    url: `/api/v1/qualificationsandCompetenceInfos`,
    method: "post",
    params,
  });
}

//详情
export function getQualificationsandCompetenceInfosItem(params) {
  return request({
    url: `/api/v1/qualificationsandCompetenceInfos/${params.id}`,
    method: "get",
    params,
  });
}

export function templateQualificationsandCompetenceInfo(params) {
  return request({
    url: `/api/v1/qualificationsandCompetenceInfo/import/template`,
    method: "get",
    params,
  });
}

export function importQualificationsandCompetenceInfo(data) {
  return request({
    url: `/api/v1/qualificationsandCompetenceInfo/import`,
    method: "post",
    data,
  });
}

// 155、银行账户

//列表
export function getBankAccountInfos(params) {
  return request({
    url: `/api/v1/bankAccountInfos`,
    method: "post",
    params,
  });
}

//详情
export function getBankAccountInfosItem(params) {
  return request({
    url: `/api/v1/bankAccountInfos/${params.id}`,
    method: "get",
    params,
  });
}
export function templateBankAccountInfo(params) {
  return request({
    url: `/api/v1/bankAccountInfo/import/template`,
    method: "get",
    params,
  });
}

export function importBankAccountInfo(data) {
  return request({
    url: `/api/v1/bankAccountInfo/import`,
    method: "post",
    data,
  });
}
export function deleteBankAccountInfo(data) {
  return request({
    url: `/api/v1/bankAccountInfo/delete`,
    method: "delete",
    data,
  });
}

// 156、外事信息

//列表
export function getForeignAffairInfos(params) {
  return request({
    url: `/api/v1/foreignAffairInfos`,
    method: "post",
    params,
  });
}

//详情
export function getForeignAffairInfosItem(params) {
  return request({
    url: `/api/v1/foreignAffairInfos/${params.id}`,
    method: "get",
    params,
  });
}
export function importForeignAffairInfos(data) {
  return request({
    url: `/api/v1/foreignAffairInfo/import`,
    method: "post",
    data,
  });
}

export function templateForeignAffairInfosItem(params) {
  return request({
    url: `/api/v1/foreignAffairInfo/import/template`,
    method: "get",
    params,
  });
}

export function setForeignAffairInfosPpCopyUrl(data) {
  return request({
    url: `/api/v1/foreignAffairInfo/ppCopyUrl/update`,
    method: "post",
    data,
  });
}

export function setForeignAffairInfosIqamaCopyUrl(data) {
  return request({
    url: `/api/v1/foreignAffairInfo/iqamaCopyUrl/update`,
    method: "post",
    data,
  });
}

// 157、薪酬信息

//列表
export function getCompensationInfos(params) {
  return request({
    url: `/api/v1/compensationInfos`,
    method: "post",
    params,
  });
}

//详情
export function getCompensationInfosItem(params) {
  return request({
    url: `/api/v1/compensationInfos/${params.id}`,
    method: "get",
    params,
  });
}

export function importCompensationInfo(data) {
  return request({
    url: `/api/v1/compensationInfo/import`,
    method: "post",
    data,
  });
}

export function templateCompensationInfo(params) {
  return request({
    url: `/api/v1/compensationInfo/import/template`,
    method: "get",
    params,
  });
}

//158 成本归集
//全部
export function getCostAccumulationAll(params) {
  return request({
    url: `/api/v1/costAccumulation/all`,
    method: "get",
    params,
  });
}
//列表
export function getCostAccumulations(params) {
  return request({
    url: `/api/v1/costAccumulations`,
    method: "get",
    params,
  });
}

//新增
export function addCostAccumulation(data) {
  return request({
    url: `/api/v1/costAccumulation/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateCostAccumulation(data) {
  return request({
    url: `/api/v1/costAccumulation/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteCostAccumulation(data) {
  return request({
    url: `/api/v1/costAccumulation/delete`,
    method: "delete",
    data,
  });
}

//159、历史变更记录
export function getJobInfoLogs(params) {
  return request({
    url: `/api/v1/jobInfo/${params.name}/logs`,
    method: "get",
    params,
  });
}

export function getQualificationsandCompetenceInfoLogs(params) {
  return request({
    url: `/api/v1/qualificationsandCompetenceInfo/${params.name}/logs`,
    method: "get",
    params,
  });
}

export function getForeignAffairInfoLogs(params) {
  return request({
    url: `/api/v1/foreignAffairInfo/${params.name}/logs`,
    method: "get",
    params,
  });
}
export function getBankAccountInfoLogs(params) {
  return request({
    url: `/api/v1/bankAccountInfo/${params.name}/logs`,
    method: "get",
    params,
  });
}
export function getCompensationInfoLogs(params) {
  return request({
    url: `/api/v1/compensationInfo/${params.name}/logs`,
    method: "get",
    params,
  });
}

// 160、人员信息修改申请审批
//列表
export function getEmployeeInfoChangeRequestApplications2(params) {
  return request({
    url: `/api/v1/employeeInfoChangeRequestApplications2`,
    method: "get",
    params,
  });
}
//详情
export function getEmployeeInfoChangeRequestApplicationsItem(params) {
  return request({
    url: `/api/v1/employeeInfoChangeRequestApplications/${params.key}`,
    method: "get",
    params,
  });
}

//新增
export function addEmployeeInfoChangeRequestApplication(data) {
  return request({
    url: `/api/v1/employeeInfoChangeRequestApplication/add`,
    method: "post",
    data,
  });
}

//编辑
export function editEmployeeInfoChangeRequestApplication(data) {
  return request({
    url: `/api/v1/employeeInfoChangeRequestApplication/edit`,
    method: "post",
    data,
  });
}

//删除
export function deleteEmployeeInfoChangeRequestApplication(data) {
  return request({
    url: `/api/v1/employeeInfoChangeRequestApplication/delete`,
    method: "delete",
    data,
  });
}

//审核
export function auditEmployeeInfoChangeRequestApplication(data) {
  return request({
    url: `/api/v1/employeeInfoChangeRequestApplication/audit`,
    method: "post",
    data,
  });
}

//161、人员备份
export function getmonthlyBasicInfos(params) {
  return request({
    url: `/api/v1/monthlyBasicInfos`,
    method: "post",
    params,
  });
}

//导出
export function exportmonthlyBasicInfos(params) {
  return request({
    url: `/api/v1/monthlyBasicInfo/export`,
    method: "post",
    params,
  });
}

//基本信息详情
export function getMonthlyBasicInfo(params) {
  return request({
    url: `/api/v1/monthlyBasicInfos/${params.id}`,
    method: "get",
    params,
  });
}

//银行
export function getMonthlyBankAccountInfos(params) {
  return request({
    url: `/api/v1/monthlyBankAccountInfos/${params.id}`,
    method: "get",
    params,
  });
}

//薪酬
export function getMonthlyCompensationInfo(params) {
  return request({
    url: `/api/v1/monthlyCompensationInfos/${params.id}`,
    method: "get",
    params,
  });
}

//工作
export function getMonthlyJobInfos(params) {
  return request({
    url: `/api/v1/monthlyJobInfos/${params.id}`,
    method: "get",
    params,
  });
}

//资格
export function getMonthlyQualificationsandCompetenceInfos(params) {
  return request({
    url: `/api/v1/monthlyQualificationsandCompetenceInfos//${params.id}`,
    method: "get",
    params,
  });
}

//外事
export function getMonthlyForeignAffairInfos(params) {
  return request({
    url: `/api/v1/monthlyForeignAffairInfos/${params.id}`,
    method: "get",
    params,
  });
}

//162、费用归集

//全部
export function getCostAggregationAll(params) {
  return request({
    url: `/api/v1/costAggregation/all`,
    method: "get",
    params,
  });
}

//列表
export function getCostAggregations(params) {
  return request({
    url: `/api/v1/costAggregations`,
    method: "get",
    params,
  });
}

//新增
export function addCostAggregation(data) {
  return request({
    url: `/api/v1/costAggregation/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateCostAggregation(data) {
  return request({
    url: `/api/v1/costAggregation/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteCostAggregation(data) {
  return request({
    url: `/api/v1/costAggregation/delete`,
    method: "delete",
    data,
  });
}

//163、费用大项

//全部
export function getCostMajorCategoryAll(params) {
  return request({
    url: `/api/v1/costMajorCategory/all`,
    method: "get",
    params,
  });
}

//列表
export function getCostMajorCategories(params) {
  return request({
    url: `/api/v1/costMajorCategories`,
    method: "get",
    params,
  });
}

//新增
export function addCostMajorCategory(data) {
  return request({
    url: `/api/v1/costMajorCategory/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateCostMajorCategory(data) {
  return request({
    url: `/api/v1/costMajorCategory/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteCostMajorCategory(data) {
  return request({
    url: `/api/v1/costMajorCategory/delete`,
    method: "delete",
    data,
  });
}

//163、费用子项

//全部
export function getCostSubCategoryAll(params) {
  return request({
    url: `/api/v1/costSubCategory/all`,
    method: "get",
    params,
  });
}

//列表
export function getCostSubCategories(params) {
  return request({
    url: `/api/v1/costSubCategories`,
    method: "get",
    params,
  });
}

//新增
export function addCostSubCategory(data) {
  return request({
    url: `/api/v1/costSubCategory/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateCostSubCategory(data) {
  return request({
    url: `/api/v1/costSubCategory/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteCostSubCategory(data) {
  return request({
    url: `/api/v1/costSubCategory/delete`,
    method: "delete",
    data,
  });
}

//163、费用细项

//全部
export function getCostCategoryDetailAll(params) {
  return request({
    url: `/api/v1/costCategoryDetail/all`,
    method: "get",
    params,
  });
}

//列表
export function getCostCategoryDetails(params) {
  return request({
    url: `/api/v1/costCategoryDetails`,
    method: "get",
    params,
  });
}

//新增
export function addCostCategoryDetail(data) {
  return request({
    url: `/api/v1/costCategoryDetail/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateCostCategoryDetail(data) {
  return request({
    url: `/api/v1/costCategoryDetail/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteCostCategoryDetail(data) {
  return request({
    url: `/api/v1/costCategoryDetail/delete`,
    method: "delete",
    data,
  });
}
//164、外部数据采集

//列表
export function getHRWeeklyExternals(params) {
  return request({
    url: `/api/v1/HRWeeklyExternals`,
    method: "get",
    params,
  });
}

//导出
export function exportHRWeeklyExternal(params) {
  return request({
    url: `/api/v1/HRWeeklyExternal/export`,
    method: "get",
    params,
  });
}

//导入模板
export function templateHRWeeklyExternal(params) {
  return request({
    url: `/api/v1/HRWeeklyExternal/import/template`,
    method: "get",
    params,
  });
}

//导入
export function importHRWeeklyExternal(data) {
  return request({
    url: `/api/v1/HRWeeklyExternal/import`,
    method: "post",
    data,
  });
}

//新增
export function addHRWeeklyExternal(data) {
  return request({
    url: `/api/v1/HRWeeklyExternal/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateHRWeeklyExternal(data) {
  return request({
    url: `/api/v1/HRWeeklyExternal/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteHRWeeklyExternal(data) {
  return request({
    url: `/api/v1/HRWeeklyExternal/delete`,
    method: "delete",
    data,
  });
}

//165、人数统计报表

//生成
export function createHRWeekly(data) {
  return request({
    url: `/api/v1/HRWeekly/create`,
    method: "post",
    data,
  });
}

//列表
export function getHRWeekly(params) {
  return request({
    url: `/api/v1/HRWeeklys`,
    method: "get",
    params,
  });
}

//导出
export function exportHRWeekly(params) {
  return request({
    url: `/api/v1/HRWeekly/export`,
    method: "get",
    params,
  });
}

//详情
export function getHRWeeklyItem(params) {
  return request({
    url: `/api/v1/HRWeeklys/${params.id}`,
    method: "get",
    params,
  });
}

//166、本单位工作年限

//列表
export function getLengthofServices(params) {
  return request({
    url: `/api/v1/lengthofServices`,
    method: "get",
    params,
  });
}

//导出
export function exportLengthofServices(params) {
  return request({
    url: `/api/v1/lengthofService/export`,
    method: "get",
    params,
  });
}

//导出
export function getLengthofServicesWorkExperiences(params) {
  return request({
    url: `/api/v1/lengthofService/workExperiences`,
    method: "get",
    params,
  });
}

export function getLengthofServicesOverseasWorkEvents(params) {
  return request({
    url: `/api/v1/lengthofService/overseasWorkEvents`,
    method: "get",
    params,
  });
}

//167、专业技术资格名称

//全部
export function getProfessionalTitleAll(params) {
  return request({
    url: `/api/v1/professionalTitle/all`,
    method: "get",
    params,
  });
}

//列表
export function getProfessionalTitles(params) {
  return request({
    url: `/api/v1/professionalTitles`,
    method: "get",
    params,
  });
}

//新增

export function addProfessionalTitle(data) {
  return request({
    url: `/api/v1/professionalTitle/add`,
    method: "post",
    data,
  });
}

//编辑
export function updateProfessionalTitle(data) {
  return request({
    url: `/api/v1/professionalTitle/update`,
    method: "post",
    data,
  });
}

//删除
export function deleteProfessionalTitle(data) {
  return request({
    url: `/api/v1/professionalTitle/delete`,
    method: "delete",
    data,
  });
}

// 168、外事业务导出相关接口

//商务访签延期审批导出
export function exportBusinessVisitVisaExtensionApplication(params) {
  return request({
    url: `/api/v1/businessVisitVisaExtensionApplication/export`,
    method: "get",
    params,
  });
}

//往返签证注销审批导出
export function exportCancelExitReentryApplication(params) {
  return request({
    url: `/api/v1/cancelExitReentryApplication/export`,
    method: "get",
    params,
  });
}

// 暂住证注销审批导出
export function exportCancelIqamaApplication(params) {
  return request({
    url: `/api/v1/cancelIqamaApplication/export`,
    method: "get",
    params,
  });
}

// 离境签证注销审批导出
export function exportCancelExitVisaApplication(params) {
  return request({
    url: `/api/v1/cancelExitVisaApplication/export`,
    method: "get",
    params,
  });
}

//往返签证延期审批导出
export function exportExtendExitReentryVisaApplication(params) {
  return request({
    url: `/api/v1/extendExitReentryVisaApplication/export`,
    method: "get",
    params,
  });
}

//离境签证办理审批导出
export function exportIssueExitVisaApplication(params) {
  return request({
    url: `/api/v1/issueExitVisaApplication/export`,
    method: "get",
    params,
  });
}

//多次往返签证办理审批导出
export function exportMultipleExitReentryVisaApplication(params) {
  return request({
    url: `/api/v1/multipleExitReentryVisaApplication/export`,
    method: "get",
    params,
  });
}

//其他付费导出
export function exportOtherPaymentApplication(params) {
  return request({
    url: `/api/v1/otherPaymentApplication/export`,
    method: "get",
    params,
  });
}

//单次往返签证办理审批导出
export function exportSingleExitReentryVisaApplication(params) {
  return request({
    url: `/api/v1/singleExitReentryVisaApplication/export`,
    method: "get",
    params,
  });
}

// 雇员转保导出
export function exportTransferSponsorApplication(params) {
  return request({
    url: `/api/v1/transferSponsorApplication/export`,
    method: "get",
    params,
  });
}

//临时工作签证延期审批导出
export function exportTemporaryWrokingVisaExtensionApplication(params) {
  return request({
    url: `/api/v1/temporaryWrokingVisaExtensionApplication/export`,
    method: "get",
    params,
  });
}

// 第三国访问签证办理审批导出
export function exportvistNonWorkingCountryApplication(params) {
  return request({
    url: `/api/v1/vistNonWorkingCountryApplication/export`,
    method: "get",
    params,
  });
}

// 护照信息更新导出
export function exportUpdatePassportApplication(params) {
  return request({
    url: `/api/v1/updatePassportApplication/export`,
    method: "get",
    params,
  });
}
// 169、分析指标
export function getCostAnalysisMetricsAll(data) {
  return request({
    url: `/api/v1/costAnalysisMetrics/tree`,
    method: "post",
    data,
  });
}
